import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { modalAnatomy as parts } from "@chakra-ui/anatomy";
import {Modal,ModalOverlay,ModalContent,ModalHeader,ModalFooter,ModalBody,ModalCloseButton,Button,Tooltip,Box,} from "@chakra-ui/react";

import {Col,Form,Row} from "react-bootstrap";

import "rsuite/dist/rsuite.min.css";
import {createMultiStyleConfigHelpers,defineStyle} from "@chakra-ui/styled-system";
import DatePicker from "react-datepicker";
import CurrencyFormat from 'react-currency-format';
import "react-datepicker/dist/react-datepicker.css";
import {  createOption } from "../createableSelect";
import getINRTotal from "jsFunctions/getINRAmount";
import PaymentInfoComponent from "../paymentInfoComponent";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import moment from "moment";
import { poNumberFormate,checkTotalApprovedAmountWithSpentAmount,checkApprovalAmount,calculateTotalCredit } from "jsFunctions/helperFunctions";
import CustomSelect from "components/CustomSelect";
import { FormValidation } from "validation";
import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import ClientProjectSelect from "components/ClientProjectSelect";
import { clientProjectOptions } from "jsFunctions/clientProjectOptions";
import { fetchAsyncGetTDSExpenseByRefrencePO,fetchAsyncGetPONumTDSExpense } from "redux/tdsSlice";
import RefundInfoListComponent from "../refundListInfoComponent";
import { fetchAsyncGetClient } from "redux/clientProjectSlice";
import { fetchAsyncGetVendorByID,fetchAsyncGetVendor } from "redux/vendorSlice";
import QuotationForm from "../seprateFormComponent/quatationForm";
import { FaCheck, FaFileUpload, FaPlus, FaPlusCircle } from "react-icons/fa";
import { fetchAsyncGetAllQuotation } from "redux/quotationSlice";
import DownloadExcelFile from "../DownloadExcel/downloadExcel";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import { calculateTotalGst,getOptionDataOnEdit } from "jsFunctions/calculateGst";
import ConfirmationDialog from "components/sweetAlert.js/ConfirmationDialog";
import { spentAmountValidate } from "validation/spentAmount";

import { fetchAsyncGetTotalCreditAmount,fetchAsyncGetCreditOptionsByVendorId,fetchAsyncDeleteCreditListItem } from "redux/creditSlice";
import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import { refundAmountValidate } from "validation/refundAmount";
import CreditForm from "../seprateFormComponent/creditForm";
import CreditApplicable from "../seprateFormComponent/creditApplicable";
import { addCreditAmountValidate } from "validation/creditAmount";
import { creditAmountMismatch, isValidateCredit } from "../CreditAmount/credit";
import AmountPopover from "../amountPopover/addAmountPopover";
import AddItemComponent from "./addItemComponent";
import './purchaseOrder.css'; 
import { fetchAsyncGetPONumPurchaseOrder,fetchAsyncSendRequestApprovalPurchaseOrderPayAmount,fetchAsyncSendRequestUpdateApprovalPurchaseOrderTotalPayAmount,fetchAsyncApprovePurchaseOrderTotalPayAmount,fetchAsyncRejectPurchaseOrderTotalPayAmount,fetchAsyncUpdatePurchaseOrder,fetchAsyncDeletePurchaseOrderPdf,fetchAsyncUploadPurchaseOrderPdf,fetchAsyncAddPurchaseOrderInvoiceRemark,fetchAsyncDeletePurchaseOrderPaymentListItem,fetchAsyncDeletePurchaseOrderRefundListItem } from "redux/purchaseOrder";

import PurchaseItemTds from "./purchaseItemTds";
import { findMismatchedItems } from "./helperFunction";
import prJson from "components/jsonData/purchase.json";
import commonJson from "components/jsonData/common.json";
import ExpenseDataChangeModal from "components/models/DataChange/expenseDataChangeModal";
import { taxOptions } from "../PurchaseItem/selectedOptions";
import { RiFileDownloadLine } from "react-icons/ri";
import InvoiceComponent from "../seprateFormComponent/InvoiceComponent";
import { sumOfPaymentRecordAmount,sumOfRefundAmount } from "utiils/halper";
import useFormOptions from "hooks/FormOptions/useFormOptions";
import useMinorOptions from "hooks/FormOptions/useMinorOptions";
import useMinorSubOptions from "hooks/FormOptions/useMinorSubOptions";
import TextAreaField from "../component/textAreaField";


const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const xl = defineStyle({px: "6",py: "2",fontSize: "xl"});
const sm = defineStyle({fontSize: "sm",py: "6"});
const sizes = {xl: definePartsStyle({ header: sm, dialog: xl }),};
export const modalTheme = defineMultiStyleConfig({sizes});

const PurchaseOrderForm = (props) => {
  const {openPurchaseModal,ClosePurchaseModal,isEdit = false,editData,refreshEditData,activeList,role,expenseType,prefix,moduleInfo} = props;

  const dateRange = useSelector((state) => state.dateRange); 
  const { startDate } = dateRange;
  const [poPrefix, setPoPrefix] = useState({
    prfx: prefix,
    m: new Date().getMonth() + 1,
    y: new Date().getFullYear(),
    n: 1,
  });


  const [getPoMonth, setGetPoMonth] = useState("");
  const [generatedNum, setGeneratedNum] = useState(prefix);
  const [clientOPtion, setClientOption] = useState([]);
  const [merchantOption, setMerchantOPtion] = useState([]);
  const [projectOption, setProjectOption] = useState([]);
  
  const [multipleAddRefundInfo, setMultipleAddRefundInfo] = useState([{}]);
  const [isImmediate, setIsImmediate] = useState(false);

  const [approveOrRejectRemarks, setApproveOrRejectRemarks] = useState('')
  const [adjustmentAmount,setAdjustmentAmount] = useState("");
  const [adjustmentLabel,setAdjustmentLabel] = useState("Adjustment")

  const [multipleCredit, setMultipleCredit] = useState([]);
  const [billNumber, setBillNumber] = useState("")
  const [totalAmount, setTotalAmount] = useState('');
  const [INRVal, setINRVal] = useState();
  const [convertedVal, setConvertedVal] = useState("");
  const [isFreight, setIsFreight] = useState(false);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
  const [approvalAmount, setApprovalAmount] = useState('');

  const [creditAmount, setCreditAmount] = useState("");
  const [paymentStatus, setPaymentStatus] = useState(0);

  const [clientValue, setClientValue] = useState("");
  const [taxableAmount, setTaxableAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false)

  const [projectValue, setProjectValue] = useState("");
  const [merchantValue, setMerchantValue] = useState("");
  const [expenseValue, setExpenseValue] = useState("");
  const [agencyValue, setAgencyValue] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [deliveryDate, setDeliveryDate] = useState(new Date());

  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [reimbursePaymentDate, setReimbursePaymentDate] = useState(new Date());
  const [currencyValue, setCurrencyValue] = useState("");
  const [multipleInvoiceData, setMultipleInvoiceData] = useState([]);
  const dispatch = useDispatch();
  const [multipleAddPaymentInfo, setMultipleAddPaymentInfo] = useState([]);
  const [multipleItemList, setMultipleItemList] = useState([{
    slItm:{},
    qty:1,
    prc:"",
    tax:{},
    amt:0,
    tdsPrc:0,
    tlAmt:0
  }]);


  const [spentAmountError, setSpentAmountError] = useState([{}]);
  const [refundAmountError, setRefundAmountError] = useState([{}]);

  const [creditError, setCreditError] = useState([{}]);

  const [totalCreditAmount,setTotalCreditAmount] = useState(0)
  const [compareDataModal, setCompareDataModal] = useState(false);
  const [comparingData, setComparingData] = useState(null);
  const [isGst, setIsGst] = useState(false);
  const [isRefund, setIsRefund] = useState(false);
  const [addCredit, setAddCredit] = useState(false)
  const [multipleAddGstInfo, setMultipleAddGstInfo] = useState([""]);
  const [isTds, setIsTds] = useState(false);
  const [amountTotal, setAmountTotal] = useState('');
  const [tdsAmount, setTdsAmount] = useState(0);
  const [tdsPercent, setTdsPercent] = useState(10);
  const [isBlink, setIsBlink] = useState(false)
  const [isGenerateTDSPo, setIsGenerateTDSPo] = useState(false);
  const [generatedTDSpoNum, setGeneratedTDSpoNum] = useState("PR-T-");
  const [fullTdsData, setFullTdsData] = useState({})
  const [tdsPoPrefix, setTdsPoPrefix] = useState({
    prfx: "PR-T-",
    m: new Date().getMonth() + 1,
    y: new Date().getFullYear(),
    n: 1,
  });

  const [openQuotation, setOpenQuotation] = useState(false)  
  const [quotationData, setQuotationData] = useState({
    remarks:"",
    amount:"",
    files:""
  })

  const [isCredit, setIsCredit] = useState(false);
  const [roundOfAmount,setRoundOfAmount] = useState("")
  const [creditValid, setCreditValid] = useState(true)
  const [isAddCredit,setIsAddCredit] = useState(false)

  const startOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
  const endOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0); 
  
  const {
    expenseOption,
    agencyOption,
    currencyOption,
    formOptionsList,
    createNewFormOption,
    deleteFormOption,
    editFormOption,
  } = useFormOptions(expenseType);

  const {
    minorTypeOption,
    createSubCategory,
    editSubCategory,
    deleteSubCategory,
    getMinorOptions,
    minorTypeValue,
    setMinorTypeValue
  } = useMinorOptions(expenseType);

  const {
    minorSubCategoryOption,
    getMinorSubOptions,
    createMinorSubCategory,
    deleteMinorSubCategory,
    editMinorSubCategory,
    minorSubCategoryValue,
    setMinorSubCategoryValue
  } = useMinorSubOptions(expenseType);

  useEffect(()=>{
    if(startDate && !isEdit){
      const formattedMonth = moment(startDate).format("YYYY-MM");
      setGetPoMonth(formattedMonth);
    }
    else{ 
      setGetPoMonth(moment().format("yyyy-MM"))
    }
    
  },[startDate])
  
  const [allCreditOption, setAllCreditOptions] = useState([])
  useEffect(()=>{
    if(getPoMonth && !isEdit){
      const formattedMonth = moment(getPoMonth).format("YYYY-MM");
      setGetPoMonth(formattedMonth);
      if (moment(formattedMonth).isSame(moment(), 'month')) {
        const creditDate = moment().toDate(); 
        setSelectedDate(creditDate); 
      }
      else{
        const firstDayOfMonth = moment(formattedMonth).startOf('month').toDate();
        setSelectedDate(firstDayOfMonth);
      }
    }
    
  },[getPoMonth])
  
  const [allQuotation,setAllQuotation] = useState([])
  
  const [allCreditData, setAllCreditData] = useState([])
  
  const finalRef = useRef(null);
  const { addToast } = useToasts();
  const [remarksValue, setRemarksValue] = useState('');
  const [errors, setErrors] = useState({})
  const clientData = useSelector((state) => state.clientData);
  const vendorList = useSelector((state) => state.vendorData);
  
  const [activeTab, setActiveTab] = useState('items')
  
  const initialValues = {
    poNo: "",
    orderMonth: null,
    orderDate: null,
    clientName: "",
    projectName: "",
    merchantName: "",
    remarks: "",
    expenseType: "",
    isExpense: false,
    agency: "",
    trackingNum: editData?.exp?.trkNo || "",
    totalPayAmount: 0,
    payee: "",
    paymentAmount: 0,
    approvalAmount: 0,
    bank: "",
    referenceNo: "",
    paymentdate: null,

    invoiceNum: editData?.rmbInfo?.inNo || "",
    invoiceDate: null,
    isReimburse:
      editData?.rmbInfo?.isRmb?.sts || false,

    reimbursePaymentDate: null,
    currency: "",
    reimburseAmount: 0,
    conversionRate: 0,
    amountInINR: 0,
    invoice: "",
  };

  const totalSpentAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
      if (multipleAddPaymentInfo.length > 0) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        const totalRefund = sumOfRefundAmount(multipleAddRefundInfo || [])

        return parseFloat(total) - parseFloat(totalRefund); 
      }
    }
    return 0;
  }, [multipleAddPaymentInfo,multipleAddRefundInfo]);

  const remainingAmount = useMemo(() => {
    if (multipleAddPaymentInfo) {
        const total = sumOfPaymentRecordAmount(multipleAddPaymentInfo || [])
        return parseFloat(totalPaymentAmount) - (parseFloat(tdsAmount) + parseFloat(creditAmount) + parseFloat(total)); 
    }
    return 0;
  }, [multipleAddPaymentInfo,totalPaymentAmount,tdsAmount,creditAmount]);

  useEffect(() => {
    dispatch(fetchAsyncGetClient())
    dispatch(fetchAsyncGetVendor());
    if(!isEdit){
      setTimeout(() => {
        setIsBlink(true)
      }, 3000); 
      setTimeout(() => {
        setIsBlink(false);
      }, 4000); 
    }
  }, []);
  useEffect(() => {
    setGeneratedNum(poNumberFormate(poPrefix));
  }, [poPrefix]);

  useEffect(() => {
    if (!isEdit && getPoMonth) {
      const dataSplit = getPoMonth.split("-");
      dispatch(
        fetchAsyncGetPONumPurchaseOrder({
          prefix:prefix,
          month: dataSplit[1],
          year: dataSplit[0],
        })
      )
        .then((res) => {
          let newNumber = 1;
          if (res.payload?.[0]?.poNo) {
            newNumber = res.payload?.[0]?.poNo.n + 1;
          }
          setPoPrefix((prev) => {
            return {
              prfx: prev.prfx,
              m: dataSplit[1],
              y: dataSplit[0],
              n: newNumber,
            };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getPoMonth]);


  const getAllMerchantOptions = async()=>{
    const filteredVendors = vendorList.filter(vendor => vendor.isV === true);

      const companyOption = await clientProjectOptions('name','_id',filteredVendors) 
      setMerchantOPtion(companyOption);
  }
  useEffect(()=>{
    if(vendorList){
      getAllMerchantOptions()
    }
  },[vendorList])



  useEffect(() => {
    if(currencyValue && currencyValue?.value !== 'INR'){
      setConvertedVal(getINRTotal(totalAmount, INRVal));
    }
    else{
      setConvertedVal(totalAmount);
      setINRVal(1)
    }  
  }, [INRVal, totalAmount,currencyValue]);
  const closeComparedDataModal = () => {
    setCompareDataModal(false);

    setComparingData(null);
  };
  const submitUpdateData = (formData, editData) => {
    setIsLoading(true)
    dispatch(
      fetchAsyncUpdatePurchaseOrder({ id: editData._id, data: formData })
    )
      .then((res) => {
        if (res.payload) {
          setIsLoading(false)
          const msg = prJson.confirm.updatePurchase.replace("{generatedNum}", generatedNum);
          addToast(msg, { appearance: "success" });
        }
        ClosePurchaseModal('approved');
        formik.resetForm();
      })
      .catch((error) => {
        setIsLoading(false)
        addToast("Error", { appearance: "error" });
      });
  };

  const getAllClientOptions = async()=>{
    if(clientData){

      const clientOption = await clientProjectOptions('clName','_id',clientData) 
      setClientOption(clientOption);
    }
  }

  const getAllProjectOptions = async(clientId)=>{
    const client = clientId && clientData.find(client => client._id === clientId);
    if(client){

      const projects = client?.prjs || []
      if(projects){
        const projectOption = await clientProjectOptions('prj','_id',projects) 
        setProjectOption(projectOption);
        setProjectValue("");
        if (isEdit && editData && editData?.prId && editData.prId?._id) {
              const subCat = projectOption.filter(
                (option) => option.value === editData.prId?._id
              );
              if (subCat[0]) {
                setProjectValue({
                  label: subCat[0].label,
                  value: subCat[0].value,
                });
              }
            }
      }
     
    }
}

  useEffect(() => {
    if (!isEdit && role === 'Accountant') {
      const projectOption = clientProjectOptions('prj','_id', clientData?.flatMap(c => c.prjs) ?? [])
      setProjectOption(projectOption);
    } else {
      getAllProjectOptions(editData?.clId?._id);
    }
  }, [])

  const handleUpdateClientValue = (newValue) => {
    setClientValue(newValue)
    getAllProjectOptions(newValue?.value)
  }
  
  useEffect(() => {
    getAllClientOptions()
  
  }, [formOptionsList]);

  const getFormData = (values)=>{
    let formData = new FormData();
    formData.append("poNo", JSON.stringify(poPrefix));
    formData.append("orderMonth", getPoMonth);
    formData.append("orderDate", selectedDate);
    formData.append("deliveryDate", deliveryDate);
    formData.append("isImmediate", isImmediate);
    formData.append("merchantName", merchantValue?.label);

    formData.append("adjustmentAmount", adjustmentAmount);
    formData.append("roundOfAmount", roundOfAmount);
    formData.append("expense_name", moduleInfo?.name);
    formData.append("adjustmentLabel", adjustmentLabel);
    formData.append("category", moduleInfo?._id)
    formData.append("clientName", clientValue?.value);
    formData.append("taxableAmount", taxableAmount);
    formData.append("projectName", projectValue?.value);
    formData.append("merchantId", merchantValue.value || "");
    formData.append("remarks", remarksValue);
    formData.append("majorId", expenseValue.id || "");
    formData.append("minorId", minorTypeValue?.id || "");
    formData.append("minorSubCategoryId", minorSubCategoryValue?.id || "");
    formData.append("agencyId", agencyValue?.id || "");
    formData.append("expenseType", expenseValue?.value);
    formData.append("minorTypeCategory", minorSubCategoryValue.value ? minorSubCategoryValue.value : '');
    formData.append("agency", agencyValue?.value);
    formData.append("minorType", minorTypeValue.value);
    formData.append("billNumber", billNumber);

    formData.append("isExpense", isFreight);
    formData.append("agency", agencyValue?.value || "");
    formData.append("trackingNum", values.trackingNum);
    formData.append("totalPaymentAmount", totalPaymentAmount);
    formData.append("approvalAmount", approvalAmount);
    formData.append("isGST", isGst);
    formData.append("isTDS", isTds);
    amountTotal && formData.append("totalAmount", amountTotal);
    formData.append("tdsPercent", tdsPercent);
    !isNaN(tdsAmount) && formData.append("totalTDS", tdsAmount);
    formData.append("isTDSPO", isGenerateTDSPo);
    formData.append("TDSPONum", JSON.stringify(tdsPoPrefix));
    formData.append("invoiceNum", values.invoiceNum);
    formData.append("invoiceDate", invoiceDate);
    formData.append("isReimburs", values.isReimburse);
    formData.append("reimbursementPaymentDate", reimbursePaymentDate);
    formData.append("currencyId", currencyValue?.id || "");
    totalAmount && formData.append("reimburseAmount", totalAmount);
    INRVal && formData.append("conversionRate", INRVal);
    convertedVal && formData.append("amountInINR", convertedVal);
    formData.append("gstInfo", JSON.stringify(multipleAddGstInfo));
    formData.append("isRefund", isRefund);
    const filteredMultipleAddRefundInfoPay = multipleAddRefundInfo?.filter((item) => item?.amt);      
    
    formData.append("refundInfo", JSON.stringify(filteredMultipleAddRefundInfoPay));
    formData.append("approveRejectRemarks", approveOrRejectRemarks);

    if(quotationData  && (quotationData?.files?.length > 0 || quotationData?.remarks)){
      formData.append('quotation_remarks', quotationData?.remarks);
     formData.append('quotation_amount', quotationData?.amount);
     Array.from(quotationData?.files).forEach((file) => {
         formData.append('quotation_files', file);
     });

   }
   const filteredInvoice = multipleInvoiceData?.filter((item) => item?.file);     
   formData.append("invoiceData", JSON.stringify(filteredInvoice));
   filteredInvoice.forEach((inv, idx) => {
    formData.append(`invoiceFiles[${idx}]`, inv.file);
   });
    return formData;
  }

  const formik = useFormik({
    initialValues,
    validationSchema: FormValidation,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      if (!clientValue || !minorTypeValue  || !projectValue || !merchantValue || !expenseValue || (minorSubCategoryOption && minorSubCategoryOption?.length && !minorSubCategoryValue)) {
        setErrors({
          ...errors,
          projectValue:prJson.required.project,
          minorTypeValue:prJson.required.minorType,
          merchantValue:prJson.required.merchant,
          expenseValue:prJson.required.majorType,
          clientValue: prJson.required.clientName,
          minorSubCategoryValue:minorSubCategoryOption && minorSubCategoryOption?.length ?  prJson.required.minorSub: ''
        })     
        addToast(prJson.required.allField, { appearance: "error" });
        return;
      }
     
      const spentError = spentAmountValidate(
        multipleAddPaymentInfo,remainingAmount
      );
      if (Object.keys(spentError).length !== 0) {
        setSpentAmountError(spentError)
        if(activeTab && activeTab !== 'spent'){
          addToast(prJson.error.checkSpent, { appearance: "error" });
        }
        return;
      }
     
      if(isRefund){
        const refundError = refundAmountValidate(
          multipleAddRefundInfo,remainingAmount
        );
        if (Object.keys(refundError).length !== 0) {
          setRefundAmountError(refundError)
          if(activeTab !== 'refund'){
            addToast(prJson.error.checkRefund, { appearance: "error" });
          }
          return;
        }
        }
      const checkApproval = checkApprovalAmount(
        approvalAmount,
      );
      if (!checkApproval.status) {
        setErrors({
          ...errors,
          approvalAmount:checkApproval.msg
        })         
        return;
      }
      const filteredMultipleAddPaymentInfo = multipleAddPaymentInfo.filter((item) => item?.amt);

      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        filteredMultipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })
        // addToast(checkValid.msg, { appearance: "error" });
        return;
      }

      let formData = getFormData(values);

      const filteredMultipleAddPaymentInfoPay = filteredMultipleAddPaymentInfo.map((item)=>{
        if(item?.inv){
          return {
            ...item,
            inv: item?.inv.filter(entry => 'Key' in entry)
          }
        }
        else{
          return item
        }
      });
     
      formData.append("payInfo", JSON.stringify(filteredMultipleAddPaymentInfoPay));
      const filteredMultipleItemData = multipleItemList.filter((item) => item?.slItm?._id);      
      formData.append("itemInfo", JSON.stringify(filteredMultipleItemData));
      if (isEdit) {
        setComparingData(formData);
      } 
    },
  });


  const handleInvoiceChange = () => {
    if(multipleInvoiceData){
      if (multipleInvoiceData?.length < 5) {
       setMultipleInvoiceData([
         ...multipleInvoiceData,
         {
           spId:"",
           Key:"",
           remark:"",
           file:""
         },
       ])
    }
   }
  };
  const handleMultiplePayInfo = (data) => {
    setMultipleAddPaymentInfo([
      ...multipleAddPaymentInfo,
      {
        amt:remainingAmount,
        pmtDt:new Date()
      },
    ]);
  };
 
  const handleUpdateMultiplePayData = (payData, index) => {
    const updateList = multipleAddPaymentInfo.map((item, i) => {
      if (i === index) {
        return {...item,...payData};
      } else return item;
    });

    const sum = updateList.reduce((acc, current) => {
      if (current?.amt && current?.amt !== '') {
        return acc + parseFloat(current?.amt);
      } else {
        return acc;
      }
    }, 0);  

    const total_pay_amount = parseFloat(totalPaymentAmount) - parseFloat(tdsAmount)
    if(total_pay_amount){

      const remaning = parseFloat(total_pay_amount) - parseFloat(sum)
      const spentError = spentAmountValidate(
        updateList,
        remaning
      );
      if (spentError) {
        setSpentAmountError(spentError)
      }
    }
    setMultipleAddPaymentInfo([...updateList]);
  };


  const handleMultipleRefundInfo = (data) => {
    setMultipleAddRefundInfo([
      ...multipleAddRefundInfo,
      "",
    ]);
  };
  const handleUpdateMultipleRefundData = (payData, index) => {
    const updateList = multipleAddRefundInfo.map((item, i) => {
      if (i === index) {
        return {...item,...payData};
      } else return item;

    });
    const refundError = refundAmountValidate(
      updateList,
      remainingAmount
    );
    if (refundError) {
      setRefundAmountError(refundError)
    }
    else{
      setRefundAmountError({})
    }
    setMultipleAddRefundInfo([...updateList]);
  };

  const handleUpdatedMultipleCredit = (newItem) => {
  const updatedList = multipleCredit.map((item)=>{
    if(item?._id === newItem?._id){
      return newItem
    }
    else{
      return item;
    }
  })
  const creditError = addCreditAmountValidate(
    updatedList,totalCreditAmount
  );
  if (creditError) {
    setCreditError(creditError)
  }
 
  setMultipleCredit(updatedList);
 
  };

 
  
  const handleUpdateInvoiceData = (invoiceData, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].file = invoiceData;
    setMultipleInvoiceData(newData);
  };
  const handleAddInvoiceRemarks = (value, index) => {
    const newData = [...multipleInvoiceData];
    newData[index].remark = value
    setMultipleInvoiceData(newData);
  };
  const handelDeleteInvoice = (index,id) => {
    if(multipleInvoiceData){
      let invoices = multipleInvoiceData.filter((item, i) => i !== index)
      setMultipleInvoiceData(invoices);
    }
  };


  const handleQuotationData = (data)=>{
    setQuotationData(data)
  }



  useEffect(() => {
    if (isEdit && editData) {
      if (!fullTdsData?.referenceResourcePO) {
        setGeneratedTDSpoNum(poNumberFormate(tdsPoPrefix));
      }
    } else {
      setGeneratedTDSpoNum(poNumberFormate(tdsPoPrefix));
    }
  }, [tdsPoPrefix, isGenerateTDSPo]);


 // TDS PO BY Resource
 useEffect(() => {
  const dataSplit = getPoMonth.split("-");
  const year =
    parseInt(dataSplit[1]) === 12
      ? parseInt(dataSplit[0]) + 1
      : parseInt(dataSplit[0]);
  let month = parseInt(dataSplit[1]) === 12 ? 1 : parseInt(dataSplit[1]) + 1 ;
  dispatch(
    fetchAsyncGetPONumTDSExpense({
      month: month,
      year: year,
    })
  )
    .then((res) => {
      if (res.payload?.[0]?.poNo) {
        if(fullTdsData?.referenceResourcePO){
          setTdsPoPrefix((prev) => {
            return {
              prfx: res.payload?.[0]?.poNo.prfx,
              m: res.payload?.[0]?.poNo.m,
              y: res.payload?.[0]?.poNo.y,
              n: res.payload?.[0]?.poNo.n,
            };
          });
        }
        else{

          setTdsPoPrefix((prev) => {
            return {
              prfx: prev.prfx,
              m: month,
              y: year,
              n: res.payload?.[0]?.poNo.n + 1,
            };
          });
        }
      } else {
        setTdsPoPrefix((prev) => {
          return {
            prfx: prev.prfx,
            m: month,
            y: year,
            n: 1,
          };
        });
      }
    })
    .catch((err) => {
      console.log("error", err);
    });
}, [isGenerateTDSPo, getPoMonth]);


  const editFormPrefiledData = (formOptionsList, editData) => {
    const clientData = editData?.clId
    if (clientData) {
      setClientValue({ label: clientData.clName, value: clientData._id });
    }

    const expense = getOptionDataOnEdit(
      formOptionsList,
      editData?.mjId?._id,
      "expense"
    );
    if (expense) {
      setExpenseValue({
        label: expense.lab,
        value: expense.val,
        id: expense?._id
      });
    }
    if (editData?.exp?.sts) {
      const agencyData = getOptionDataOnEdit(
        formOptionsList,
        editData?.exp?.adId?._id,
        "agency"
      );
    
      if (agencyData && !agencyValue) {
        setAgencyValue({
          label: agencyData.lab,
          value: agencyData.val,
          id: agencyData?._id
        });
      }
    }
  };

  

  const handleCloseQuotation = ()=>{
    setOpenQuotation(!openQuotation)
    if (isEdit && editData) {
    getAllQuotation(editData?._id)
    }
  }


  const getAllQuotation = async(_id)=>{
    await dispatch(fetchAsyncGetAllQuotation(_id)).then((res)=>{

        if(res?.payload){
            const quotations = res.payload?.quotations;
            setAllQuotation(quotations)
        }
        }).catch((err)=>{
          console.log(err)
        })
}

const getMerchantByID = async(id)=>{
  await dispatch(fetchAsyncGetVendorByID(id)).then((res)=>{

  if(res?.payload){
    const vendor = res?.payload?.vendor;
    const setData = {
      label: vendor.name,
      value: vendor?._id,
    };
          
    setMerchantValue(setData);
  }
  }).catch((err)=>{
    console.log(err)
  })
}
useEffect(()=>{
  if (formOptionsList?.length > 0 && editData) {
    editFormPrefiledData(formOptionsList, editData);
  }
},[formOptionsList,editData]);

  useEffect(() => {
    // fill data in form on edit
    if (isEdit && editData) {
    
      getAllQuotation(editData?._id)

      setPoPrefix(editData.poNo);
      setSelectedDate(new Date(editData.oDt));
      setDeliveryDate(new Date(editData?.dlDt));
      setIsImmediate(editData?.imDate);

      setGetPoMonth(
        `${editData.poNo.y}-${
          editData.poNo.m < 9
            ? "0" + editData.poNo.m
            : editData.poNo.m
        }`
      );

     
      if(editData?.mrId && editData?.mrId?._id){
        getMerchantByID(editData?.mrId?._id)
      }
      
     
      setIsFreight(editData?.exp?.sts || false);
      if (editData.pyInfo?.tlAmt) {
        setTotalPaymentAmount(editData.pyInfo?.tlAmt);
      }
      if (editData.pyInfo?.list && editData.pyInfo?.list.length > 0) {
        setMultipleAddPaymentInfo(editData.pyInfo?.list);
      }
      if(editData.pyInfo?.inv && editData.pyInfo?.inv?.length > 0) {
        setMultipleInvoiceData(editData.pyInfo?.inv);
      }
      if (editData.pyInfo?.itms && editData.pyInfo?.itms.length > 0) {
        setMultipleItemList(editData.pyInfo?.itms);
      }
     
      if (editData?.acRmks) {
        setApproveOrRejectRemarks(editData?.acRmks)
      }
      if (editData?.pyInfo?.blNo) {
        setBillNumber(editData?.pyInfo?.blNo)
      }
      else if(editData.pyInfo?.list && editData.pyInfo?.list?.length > 0) {
        setBillNumber(editData.pyInfo?.list[0]?.blNo);
      }
      if (editData?.adjAmt) {
        setAdjustmentAmount(editData?.adjAmt)
      }
      if (editData?.adjLab) {
        setAdjustmentLabel(editData?.adjLab);
      }
      if (editData?.roAmt) {
        setRoundOfAmount(editData?.roAmt)
      }
      if (editData?.rmks) {
        setRemarksValue(editData?.rmks)
      }
      if (editData.rfdInfo?.list && editData.rfdInfo?.list.length > 0) {
        setMultipleAddRefundInfo(editData.rfdInfo?.list);
      }
      if (editData.pyInfo?.txAmt) {
        setTaxableAmount(editData.pyInfo?.txAmt);
      }
      if (editData.pyInfo?.sts) {
        setPaymentStatus(editData.pyInfo?.sts)
      }
      if (editData?.gstApl && editData?.gstApl?.sts) {
        setIsGst(editData?.gstApl?.sts);
      }
      if (editData?.crApl && editData?.crApl?.sts) {
        setIsCredit(editData?.crApl?.sts);
      }
      if (editData?.crApl?.list && editData?.crApl?.list?.length > 0) {
        setMultipleCredit(editData.crApl?.list);
      }
    
      if (editData?.rfdInfo && editData?.rfdInfo?.sts) {
        setIsRefund(editData?.rfdInfo?.sts);
      }
    
      
     
      if (editData.pyInfo?.apAmt) {
        setApprovalAmount(editData.pyInfo?.apAmt);
      }
     
      if (editData.rmbInfo?.inDt) {
        setInvoiceDate(new Date(editData.rmbInfo.inDt));
      }
      if (editData.gstApl?.gstId && editData.gstApl?.gstId?.length > 0) {
        setMultipleAddGstInfo(editData.gstApl?.gstId);
      }
     
     
      if(editData.tdsApplicable?.tdsPercent) {

        setTdsPercent(editData.tdsApplicable?.tdsPercent);
      }
      if (editData.rmbInfo?.isRmb) {
        const { pmtDt, amt, cnvRt, inr } =
          editData.rmbInfo?.isRmb;
        pmtDt && setReimbursePaymentDate(new Date(pmtDt));
        setTotalAmount(amt);
        setINRVal(cnvRt);
        setConvertedVal(inr);

        const currencyData = getOptionDataOnEdit(
          formOptionsList,
          editData.rmbInfo?.isRmb?.crId,
          "currency"
        );
        if (currencyData) {
          setCurrencyValue({
            label: currencyData.lab,
            value: currencyData.val,
            id: currencyData?._id

          });
        }
      }
    
      if(editData?._id){
        dispatch(fetchAsyncGetTDSExpenseByRefrencePO(editData?._id)).then((res)=>{
          const tdsData = res?.payload?.tdsExpense
          if (res?.payload && tdsData) {
            if (tdsData?.rfPo) {
              setIsTds(editData.tdsApl?.sts);
              setAmountTotal(tdsData?.tlBlAmt);
              setTdsAmount(tdsData?.tdsAmt);
              setIsGenerateTDSPo(true);
              setGeneratedTDSpoNum(poNumberFormate(tdsData?.poNo));
            }
            setFullTdsData(tdsData);
          } else {
            if (editData.tdsApl?.sts) {
              setIsTds(editData.tdsApl?.sts);
              editData.tdsApl?.bsAmt && setAmountTotal(editData.tdsApl?.bsAmt);
              editData.tdsApl?.tlAmt && setTdsAmount(editData.tdsApl?.tlAmt);
            }
          }
        }).catch((err)=>{
          console.log(err)
        })
      }
     
    }
  }, [isEdit,editData]);

  const handleDeleteInvoiceOnEdit = (key,spId) => {
    ConfirmationDialog({
      title: prJson.confirm.invoice,
      text: `Delete File ${key}`,
      icon: "warning",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true)

        const sendData = {
          id: editData._id,
          key: key,
          spId: spId || ""
        };
        dispatch(fetchAsyncDeletePurchaseOrderPdf(sendData)).then((res) => {
          if(res?.payload && res?.payload?.purchaseOrder?.pyInfo?.inv){

          setMultipleInvoiceData(res?.payload?.purchaseOrder?.pyInfo?.inv)
          refreshEditData();
          addToast(prJson.success.deletedInvoice, { appearance: "success" });
          setIsLoading(false)
          }
          else{
            setIsLoading(false)
            addToast(prJson.error.generic, { appearance: "error" });
          }

        }).catch((error) => {
          addToast(prJson.error.generic, { appearance: "error" });
          setIsLoading(false);
      });
      },
    });
  };

  const addNewInvoiceOnEdit = (file, index) => {
    ConfirmationDialog({
      title: prJson.confirm.uploade,
      text: `Upload - ${file.name}`,
      icon: "warning",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        setIsLoading(true)

        if (editData) {
        
          let formData = new FormData();
          formData.append("poNo", JSON.stringify(editData.poNo));
          formData.append("file", file);
          formData.append("merchantId", merchantValue.val || "");
          formData.append("index", index);

          dispatch(
            fetchAsyncUploadPurchaseOrderPdf({ id: editData._id, formData })
          ).then((res) => {
            if(res?.payload && res?.payload?.purchaseOrder?.pyInfo?.inv){
              setMultipleInvoiceData(res?.payload?.purchaseOrder?.pyInfo?.inv)
            refreshEditData();
            setIsLoading(false)
            addToast(prJson.success.uploaded, { appearance: "success" });
            }
            else{
              setIsLoading(false);
              addToast(prJson.error.generic, { appearance: "error" });
            }
          }).catch((error) => {
            addToast(prJson.error.generic, { appearance: "error" });
            setIsLoading(false);
        });
        }
      },
    });
  };

 
  useEffect(() => {
    if (minorTypeValue?.id) {
      getMinorSubOptions(minorTypeValue?.id,editData?.msId?._id)
    }
  }, [minorTypeValue,editData]);


     // Set MinorCategory for selected majorType value
   useEffect(() => {
    if (expenseValue?.id) {
      getMinorOptions(expenseValue?.id,editData?.mnId?._id)
    }
    
  }, [expenseValue,editData]);
  
  const addRemarkForInvoice = (value,index) => {
    dispatch(
      fetchAsyncAddPurchaseOrderInvoiceRemark({
        id: editData._id,
        remarkData: {  remark: value, index },
      })
    ).then((res) => {
      setMultipleInvoiceData(res?.payload?.purchaseOrder?.pyInfo?.inv)

      refreshEditData();
    });
  };

  const handleAmountApproveBtn = (values)=>{   
    if(!isEdit){
  
      if ((paymentStatus === 0 && !clientValue)  || !minorTypeValue || (paymentStatus === 0 && !projectValue) || (paymentStatus === 0 && !merchantValue)|| !expenseValue  || (minorSubCategoryOption && minorSubCategoryOption?.length && !minorSubCategoryValue)) {
        setErrors({
          ...errors,
          projectValue:paymentStatus === 0 ? prJson.required.project :"",
          minorTypeValue:prJson.required.minorType,
          merchantValue:paymentStatus === 0 ? prJson.required.merchant:"",
          expenseValue:prJson.required.majorType,
          clientValue:paymentStatus === 0 ? prJson.required.clientName:"",
          minorSubCategoryValue:minorSubCategoryOption && minorSubCategoryOption?.length ?  prJson.required.minorSub: ''
        }) 
          addToast(prJson.required.allField, { appearance: "error" });
           return;
         }
    }
    const checkApproval = checkApprovalAmount(
      approvalAmount,
    );
    if (!checkApproval.status) {
      setErrors({
        ...errors,
        approvalAmount:checkApproval.msg
      }) 
    return;
    }
   
    if(isCredit){
      const creditError = addCreditAmountValidate(
        multipleCredit,totalCreditAmount
      );
      if (Object.keys(creditError).length !== 0) {
        setCreditError(creditError)
        if(activeTab && activeTab !== 'credit'){
          addToast(prJson.error.checkCredit , { appearance: "error" });
        }
        return;
      }
      const amount = parseFloat(taxableAmount) - parseFloat(tdsAmount) -  parseFloat(creditAmount);
      if(amount < 0){
        addToast(prJson.error.invalidCredit, { appearance: "error" });
        return;
      }
      if(!creditValid){
        return;
      }
    }

    if(approvalAmount <= totalPaymentAmount && remainingAmount >= 0){
  
      const checkValid = checkTotalApprovedAmountWithSpentAmount(
        totalPaymentAmount,
        multipleAddPaymentInfo
      );
      if (!checkValid.status) {
        setErrors({
          ...errors,
          approvalAmount:checkValid.msg
        })           
        return;
      }
    }
    if(remainingAmount < 0 && approvalAmount <= totalPaymentAmount){
      return;
    }
      let formData = getFormData(values);
      

      formData.append("isCredit", isCredit);
      const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);      
      formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));
      const filteredMultipleItemData = multipleItemList.filter((item) => item?.slItm?._id);      
      formData.append("itemInfo", JSON.stringify(filteredMultipleItemData));

      
     setIsLoading(true)

      if(isEdit && editData){
       
        if(isTaxableAmountMismatch){
          if(multipleAddPaymentInfo?.length && approvalAmount < totalPaymentAmount){
            addToast(prJson.error.spentAmt,{ appearance: "info" });
            setIsLoading(false)
          }
          else{
              dispatch(fetchAsyncSendRequestUpdateApprovalPurchaseOrderTotalPayAmount
          ({ 
          id: editData._id,
          data:formData
         })).then(
          (res) => {
            if (res.payload && res.payload.updatedData) {
              const msg = prJson.confirm.resendRequest.replace("{generatedNum}", generatedNum);
              
              setPaymentStatus(0)
              addToast(msg, { appearance: "success" });
              setIsLoading(false)

              ClosePurchaseModal('pending');
            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
          }
        }
        
      }
      else{
        // setIsLoading(false)
        dispatch(fetchAsyncSendRequestApprovalPurchaseOrderPayAmount(formData)).then((res) => {
            if (res.payload) {
              const msg = prJson.confirm.sendRequest.replace("{generatedNum}", generatedNum);
              addToast(msg, { appearance: "success" });
            
              setPaymentStatus(0)
              setIsLoading(false)
              ClosePurchaseModal('pending');
            }
            else{
              addToast(res?.error.message, { appearance: "error" });
              setIsLoading(false)
  
            }
          }).catch((err)=>{
            addToast(err.message, { appearance: "error" });
            setIsLoading(false)
          });
      }
      
      }
  const handleTotalPayAmountIsApproved = (values)=>{
    if(isEdit){
  
      if ((paymentStatus === 0  && !clientValue)  || !minorTypeValue || (paymentStatus === 0  && !projectValue) || (paymentStatus === 0  && !merchantValue)|| !expenseValue  || (minorSubCategoryOption && minorSubCategoryOption?.length && !minorSubCategoryValue)) {
        setErrors({
          ...errors,
          projectValue:paymentStatus === 0  ? prJson.required.project : "",
          minorTypeValue:prJson.required.minorType,
          merchantValue:paymentStatus === 0  ?prJson.required.merchant:"",
          expenseValue:prJson.required.majorType,
          clientValue:paymentStatus === 0  ? prJson.required.clientName:"",
          minorSubCategoryValue:minorSubCategoryOption && minorSubCategoryOption?.length ?  prJson.required.minorSub: ''
        }) 
          addToast(prJson.required.allField, { appearance: "error" });
           return;
         }
    }
    if(parseFloat(creditAmount) > parseFloat(totalCreditAmount)){
      setErrors({
        ...errors,
        creditAmount: prJson.error.creditLimit
      })
    }
    let formData = getFormData(values);
    const _id = editData._id;

  
    if(isCredit){

      const creditError = addCreditAmountValidate(
        multipleCredit,totalCreditAmount
      );
      if (Object.keys(creditError).length !== 0) {
        setCreditError(creditError)
        if(activeTab && activeTab !== 'credit'){
          addToast(prJson.error.checkCredit , { appearance: "error" });
        }
        return;
      }
      const amount = parseFloat(taxableAmount) - parseFloat(tdsAmount) -  parseFloat(creditAmount);

      if(amount < 0){
        addToast(prJson.error.invalidCredit, { appearance: "error" });
        return;
      }
      if(!creditValid){
        return;
      }
    }

     
      formData.append("isCredit", isCredit);
      const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);      
      formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));

      const filteredMultipleItemData = multipleItemList.filter((item) => item?.slItm?._id);      
      formData.append("itemInfo", JSON.stringify(filteredMultipleItemData));

    if(editData.pyInfo?.sts === 0){
      const confirmMsg = prJson.confirm.approveAmt;
      const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.approveAction,  
        icon: "warning",
        confirmButtonText: "Approve",
        cancelButtonText: "Cancel",
        onConfirm: () => {
          setIsLoading(true)
          dispatch(fetchAsyncApprovePurchaseOrderTotalPayAmount({ 
            id: _id,
            data:formData
           })).then(
            (res) => {
              if (res.payload && res.payload.updatedData) {
                const msg = prJson.success.approved.replace("{generatedNum}", generatedNum);
                addToast(msg, { appearance: "success" });
                setIsLoading(false)
                ClosePurchaseModal('approved');
              }
              
            }
          );
        },
      });
    }
  }

  const handleTotalPayAmountIsRejected = ()=>{
    const _id = editData._id;
    let formData = new FormData();

    formData.append("isCredit", isCredit);
    const filteredMultipleCredit = multipleCredit.filter((item) => item?.usAmt);      
    formData.append("creditInfo", JSON.stringify(filteredMultipleCredit));
    formData.append("totalPayAmountIsRejected",true);

    if(editData.pyInfo?.sts === 0){
      const confirmMsg = prJson.confirm.rejectAmt;
      const title = confirmMsg.replace("{approvalAmount}", formatAmountIndianRupees(approvalAmount)).replace("{generatedNum}", generatedNum);
      ConfirmationDialog({
        title: title,
        text: prJson.confirm.rejectAction,
        icon: 'warning',
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        onConfirm: () => {
          setIsLoading(true)
          dispatch(fetchAsyncRejectPurchaseOrderTotalPayAmount({ 
            id: _id,
            data:formData
           })).then(
            (res) => {
              if (res.payload && res.payload.updatedData) {
                const msg = prJson.success.rejected.replace("{generatedNum}", generatedNum);
                addToast(msg, { appearance: "success" });
                ClosePurchaseModal('rejected');
                setIsLoading(false)
              }
            }
          );
        },
      });
    }
  
  }


  useEffect(()=>{
    if(!isTds){

      setAmountTotal(0)
      setTdsAmount(0)
      // setTdsPercent(10)
      setIsTds(false)

    }
  },[!isTds])

 
  const closeModelForm = () => {
    ConfirmationDialog({
      title: commonJson.close.confirm,
      text: commonJson.text.lost,
      icon: 'warning',
      confirmButtonText: 'Close',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        ClosePurchaseModal();

      },
    });
  };

  const handleRemarksChange = (e)=>{
    const value = e?.target?.value;
    const encoder = new TextEncoder(); 
    const byteLength = encoder.encode(value).length;
    if(byteLength <=128){
      setRemarksValue(value)
      setErrors({
        ...errors,
        remarks:''
      })
    }
    else{
      setErrors({
        ...errors,
        remarks:prJson.error.remarksLimit
      })
    }
  }

  const deleteMultipleListItem = (listIndex)=>{
    ConfirmationDialog({
      title: prJson.confirm.deleteAmt,
      text: '',
      icon: 'warning',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      onConfirm: () => {
        const sendData = {
          id: editData._id,
          listIndex:listIndex
        };
        dispatch(fetchAsyncDeletePurchaseOrderPaymentListItem(sendData)).then((res) => {
          if(res?.payload?.purchaseOrder?.pyInfo?.list && res?.payload?.purchaseOrder?.pyInfo?.list?.length){
            setMultipleAddPaymentInfo(res?.payload?.purchaseOrder?.pyInfo?.list)
          }
          else{
            setMultipleAddPaymentInfo(prevState => prevState.filter((_, i) => i !== listIndex));
          }
          addToast(prJson.success.spentAmt, { appearance: "success" });
        });
      },
    });
   
}

const deleteMultipleRefundListItem = (listIndex)=>{
  ConfirmationDialog({
    title: prJson.confirm.deleteRefundAmt,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      const sendData = {
        id: editData._id,
        listIndex:listIndex
      };
      dispatch(fetchAsyncDeletePurchaseOrderRefundListItem(sendData)).then((res) => {
        if(res?.payload?.purchaseOrder?.rfdInfo?.list && res?.payload?.purchaseOrder?.rfdInfo?.list?.length){
          setMultipleAddRefundInfo(res?.payload?.purchaseOrder?.rfdInfo?.list)
        }
        else{
          setMultipleAddRefundInfo(prevState => prevState.filter((_, i) => i !== listIndex));
        }
        addToast(prJson.success.deleteRefund, { appearance: "success" });
      });
    },
  });
}

const hasAccess = useCallback(() => {
  return (role === "Admin" || role === "Manager" || role=== "Accountant") &&  paymentStatus === 1;
}, [role,  paymentStatus]);

const isTaxableAmountMismatch = useCallback(() => {
  const editTaxableAmount = editData?.pyInfo?.txAmt || 0;
  return parseFloat(taxableAmount || 0) !== parseFloat(editTaxableAmount);
}, [taxableAmount, editData]);


const isTDSPoGenerated = useCallback(() => {
  const isTDSPO = editData?.tdsApl?.tdsPo?.sts;
  const tdsId = editData?.tdsApl?.tdsPo?.poNo?._id;
  return isTDSPO && tdsId;

}, [editData,generatedTDSpoNum]);

const isCreditAmountMismatch = useCallback(() => {
  return creditAmountMismatch(multipleCredit,editData);
}, [multipleCredit, editData]);

const isSendRequest = useCallback(() => {
  const isPending = paymentStatus === 0;
  const isTdsPOGenerated = isTDSPoGenerated();
  return ( isTaxableAmountMismatch() || isCreditAmountMismatch() || isPending) && !isTdsPOGenerated;
}, [ editData, isTaxableAmountMismatch,isTDSPoGenerated,isCreditAmountMismatch]);


const fetchTDSData = (editData) => {
  if (editData?._id) {
    dispatch(fetchAsyncGetTDSExpenseByRefrencePO(editData?._id)).then((res) => {
      const tdsData = res?.payload?.tdsExpense;
      if (res?.payload && tdsData) {
        if (tdsData?.referenceResourcePO) {
          setIsTds(editData.tdsApl?.sts);
          setAmountTotal(tdsData?.tlBlAmt);
          setTdsAmount(tdsData?.tdsAmt);
          setIsGenerateTDSPo(true);
          setGeneratedTDSpoNum(poNumberFormate(tdsData?.poNo));
        }
        setFullTdsData(tdsData);
      } else {
        if (editData.tdsApplicable?.isTDS) {
          setIsTds(editData.tdsApl?.sts);
          editData.tdsApl?.bsAmt && setAmountTotal(editData.tdsApl?.bsAmt);
          editData.tdsApl?.tlAmt && setTdsAmount(editData.tdsApl?.tlAmt);
        } else {
          setAmountTotal(editData.tdsApl?.tlAmt);
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
};

const updatedApprovalAmount = ()=>{

  const gstArray = multipleAddGstInfo.map(item => {
    if (item?.gstFullData) {
        return item?.gstFullData; 
    } if(item?._id){
      return item?._id
    } else {
        return {amt: {} }; 
    }
});  

const totalGst = calculateTotalGst(gstArray)
let totalRequestedAmt = parseFloat(taxableAmount) + parseFloat(totalGst)

setApprovalAmount(totalRequestedAmt + roundOfAmount)
}

useEffect(()=>{
  updatedApprovalAmount();
},[roundOfAmount])

useEffect(()=>{
  setTotalPaymentAmount(Number(approvalAmount))
},[approvalAmount])

useEffect(()=>{
 
  if(taxableAmount && (isTaxableAmountMismatch() || paymentStatus !== 1) &&  multipleAddGstInfo && multipleAddGstInfo?.length > 0){
    updatedApprovalAmount();
  }
    else if(isTaxableAmountMismatch()){
        if(multipleAddGstInfo && multipleAddGstInfo?.length > 0){
          updatedApprovalAmount();
        }else{
          setApprovalAmount(taxableAmount + roundOfAmount)
        }
    }
    else{
      setApprovalAmount(editData?.pyInfo?.apAmt)
    }
   
    if(totalPaymentAmount && editData?.tdsApl?.tlAmt && isTds){
      fetchTDSData(editData);
    }
    
},[
  isTaxableAmountMismatch,
  multipleAddGstInfo,
  isTds,
  isGst,
  isTDSPoGenerated,
])

const updateCreditOptions = async()=>{
  const creditIds = multipleCredit.map((item)=>{
    if(item?.crId){
      return item?.crId?._id
    }
    else{
      return item?._id;
    }
  })
  const creditList = allCreditData.filter((item)=> !creditIds.includes(item?._id))
  const creditOption = await clientProjectOptions('coNo','_id',creditList) 

  setAllCreditOptions(creditOption)
}
useEffect(()=>{
  if(multipleCredit){
    const sumOfCredit = calculateTotalCredit(multipleCredit)
    setCreditAmount(sumOfCredit)
    updateCreditOptions();
  }
},[multipleCredit,allCreditData])

const handleToggleGenerateTDSPo = () => {
  if (isGenerateTDSPo) {
    setIsGenerateTDSPo(false);
  } else {
    const title = prJson.confirm.genTdsPo.replace("{amountTotal}", formatAmountIndianRupees(amountTotal));

    ConfirmationDialog({
      title: title,
      text: prJson.text.undoneTdsPo,
      icon: 'warning',
      confirmButtonText: 'Generate',
      cancelButtonText: 'Cancel',
      onConfirm: () => setIsGenerateTDSPo(true),
    });
  }
};


const handleToggleCreditApplicable = () => {

      if(!merchantValue){
        addToast(prJson.required.merchant,{ appearance: "error" });
      }
      else{
        if(!multipleCredit.length){
          if (allCreditData.length > 0) {
            setIsCredit(!isCredit)
            const firstItem = allCreditData[0];
            const availableCredit =
              parseFloat(firstItem?.amt || 0) -
              parseFloat(firstItem?.usAmt || 0) -
              parseFloat(firstItem?.resAmt || 0);

            const remainingPayable = Math.max(remainingAmount, 0);

            const defaultCredit = Math.min(availableCredit, remainingPayable);
            const obj = {
              ...firstItem,
              usAmt:defaultCredit
            }
            setMultipleCredit([obj]); 
          }
          else{
            addToast(prJson.error.avalCredit, { appearance: "error" });
          }  
      }
      else{
        addToast(prJson.info.deleteCredit,{ appearance: "info" });
      }
    }
};

const handleToggleRefundApplicable = () => {
 
    setIsRefund(!isRefund)
    if(!multipleAddRefundInfo?.length){
      setMultipleAddRefundInfo([""])
    }
  
};

const handleSelectTab = (k) => {
  setActiveTab(k);
};

const getTotalCreditAmount = async(vendorId)=>{
  await dispatch(fetchAsyncGetTotalCreditAmount(vendorId)).then((res)=>{

    if(res?.payload){
      const total = res?.payload?.totalAmount;
      setTotalCreditAmount(total)
      
    }
    }).catch((err)=>{
      addToast(prJson.error.fetchCredit,{ appearance: "error" });

    })
}
const getAllCreditByVendorID = async(vendorId)=>{
  try {
      const res = await dispatch(fetchAsyncGetCreditOptionsByVendorId(vendorId)); 
      if (res?.payload) {
        const creditDetail = res?.payload?.filterCredit;
        const filterCredit = creditDetail?.map((item)=>{
          return {
            ...item,
            coNo:poNumberFormate(item?.crNo)
          }
        })
        const creditOption = await clientProjectOptions('coNo','_id',filterCredit) 

        setAllCreditData(filterCredit)
        setAllCreditOptions(creditOption);
        setIsLoading(false)
        if(!isEdit){
          setMultipleCredit([]);
          setIsCredit(false)
        }
      }
    } catch (error) {
      setIsLoading(false)
        addToast(prJson.error.fetchCredit, { appearance: "error" });
    }
}

const handleAddCredit = (newValue)=>{
  const creditId = newValue?.value;
  const creditData = allCreditData || [];
  const newItem = creditData?.find(item=>item._id === creditId);

  const availableCredit =
    parseFloat(newItem?.amt || 0) -
    parseFloat(newItem?.usAmt || 0) -
    parseFloat(newItem?.resAmt || 0);

  const remainingPayable = Math.max(remainingAmount, 0);

  const defaultCredit = Math.min(
    availableCredit,
    remainingPayable
  );
  const obj = {
    ...newItem,
    usAmt:defaultCredit
  }
  setMultipleCredit([...multipleCredit,obj]); 
  setAddCredit(!addCredit)
}

const validateCredits = useCallback(() => {
  return isValidateCredit(multipleCredit,editData)
}, [multipleCredit]);


const handleDeleteCredit = (id,creditId)=>{
  ConfirmationDialog({
    title: prJson.confirm.deleteCredit,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      setIsLoading(true)
      if(creditId && creditId?._id){
        const data = {
          creditId:id,
          moduleId:moduleInfo?._id,
          expenseId:editData?._id,
          status: paymentStatus === 1 ? 'approved' : 'pending',
          expenseType:expenseType
        }
        dispatch(fetchAsyncDeleteCreditListItem(data)).then((res) => {
          if(res?.payload){
            refreshEditData();
            const filterCredit = multipleCredit.filter(item=>item?.crId?._id !== id);

            setMultipleCredit(filterCredit); 
            if(filterCredit.length === 0){
              setIsCredit(!isCredit)
            }
            addToast(prJson.success.deletedCredit, { appearance: "success" });
            setIsLoading(false)
            const vendorId = merchantValue.value;
            getTotalCreditAmount(vendorId);
            getAllCreditByVendorID(vendorId)
          }
          else{
            addToast(prJson.faield.deleteCredit, { appearance: "error" });
            setIsLoading(false)
          }
        }).catch((err)=>{
          addToast(prJson.faield.deleteCredit, { appearance: "error" });
          setIsLoading(false)

        })
      }
      else{

        const filterCredit = multipleCredit.filter(item=>item._id !== id);
        setMultipleCredit(filterCredit); 
        if(filterCredit.length === 0){
          setIsCredit(!isCredit)
        }
        setIsLoading(false)
        addToast(prJson.success.deleteCredit, { appearance: "success" });
        const vendorId = merchantValue.value;
        getTotalCreditAmount(vendorId);
        getAllCreditByVendorID(vendorId)
      }
     
    },
  });
}

useEffect(()=>{
  const amount = parseFloat(taxableAmount) - parseFloat(tdsAmount) -  parseFloat(creditAmount);
  if(amount < 0){
    setErrors({
      ...errors,
      taxableAmount:prJson.error.invalidCredit
    })
  }
  else{
    setErrors({
      ...errors,
      taxableAmount:''
    })
  }

},[taxableAmount,creditAmount,tdsAmount])

useEffect(()=>{
  if(merchantValue.value){
    const vendorId = merchantValue.value;
    getTotalCreditAmount(vendorId);
    getAllCreditByVendorID(vendorId)
  }
},[merchantValue])

const handleAddAmount = (amt)=>{
  const parsedAmount = parseFloat(amt);
  if (!isNaN(parsedAmount)) {
    setRoundOfAmount(parsedAmount);
  }
}

const handleRemoveSelectedItem = (index)=>{
  const updatedData = multipleItemList.map((data,i)=>{
    const obj = {...data}
    if(i === index){
      obj.slItm = {}
      obj.prc =  0;
      obj.qty = 1;
      obj.tax = {};
      obj.amt = 0;
      obj.tdsPrc = 0;
      obj.tlAmt = 0;
      return obj
    }
    else{
      return data;
    }
  })
  setMultipleItemList(updatedData)
}
const handleMultipleListItem = (item,index)=>{
  const updatedData = multipleItemList.map((data,i)=>{
    const obj = {...data}
    const istr = item?.istr?.id? item.istr :taxOptions.find((opt)=> opt?.id === item?.istr)
    if(i === index){
      obj.slItm = item
      obj.prc = Number(item?.prc) || 0
      obj.tax = istr || {}
      obj.amt = Number(obj.qty) * obj.prc;

      return obj
    }
    else{
      return data;
    }
  })
  
  setMultipleItemList(updatedData)
}

const handleUpdateItemField = (value, name, index) => {
  const updatedData = multipleItemList.map((data, i) => {
    const obj = {...data};
    if (i === index) {

      if (name === 'description') {
        const obj1 = {
          ...data.slItm,
          dc:value
        }
        obj.slItm = obj1;
      } else if (name === 'hsnCode') {
        const obj1 = {
          ...data.slItm,
          hCd:value
        }
        obj.slItm = obj1;
      } else if (name === 'sacCode') {
        const obj1 = {
          ...data.slItm,
          sCd:value
        }
        obj.slItm = obj1;
      } else if (name === 'quantity') {
        obj.qty = Number(value) || 0; 
      } else if (name === 'rate') {
        obj.prc = Number(value) || 0; 
      }else if (name === 'tax') {
        obj.tax = value || {}; 
      }
      else if (name === 'tdsPercentage') {
        if (Number(value) < 0 || Number(value) > 100) {
          addToast(prJson.error.tdsPerLimit, { appearance: "error" });
          
        } else {
          
          obj.tdsPrc = Number(value) || 0; 
          const percentage = obj.tdsPrc || 0;
          const itemAmount = parseFloat(obj?.amt) || 0;
          const amount = (itemAmount * percentage) / 100;
          obj.tlAmt = amount
        }
        
      }
      
      obj.amt = obj.qty * obj.prc;

      if(obj?.tdsPrc > 0 && obj?.tdsPrc <= 100){
        const percentage = obj.tdsPrc || 0;
        const itemAmount = parseFloat(obj?.amt) || 0;
        const amount = (itemAmount * percentage) / 100;
        obj.tlAmt = amount
      }
      console.log(obj,'object')
      return { ...obj }; 
    } else {
      return data; 
    }
  });

  setMultipleItemList(updatedData);
};
const handleUpdateListItem = (item,index)=>{
  const updatedData = multipleItemList.map((data,i)=>{
    const obj = {...data}
    if(i === index){
      obj.slItm = item
      obj.prc = Number(item?.prc) || 0
      obj.tax = item?.istr || {}
      obj.amt = Number(obj.qty) * obj.prc;
      return obj
    }
    else{
      return data;
    }
  })
  setMultipleItemList(updatedData)
}
const handleAddRow = ()=>{
  const data = [...multipleItemList]
  data.push({
  slItm:{},
  qty:1,
  prc:"",
  tax:{},
  amt:0,
  tlAmt:0,
  tdsPrc:0
  })
  setMultipleItemList(data)
}
const handleDeleteRow = (e,index)=>{
  ConfirmationDialog({
    title: prJson.confirm.deleteItem,
    text: '',
    icon: 'warning',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    onConfirm: () => {
      e.preventDefault();
      const updatedFields =
        multipleItemList.filter(
          (_, i) => i !== index
        );
        setMultipleItemList(updatedFields);
      
    },
  });

   
}

const isGstApplicable = (gstFullData) => {
  const { amt } = gstFullData;

  const igstExists = amt?.i && amt?.i !== 0;
  const cgstExists = amt?.c && amt?.c !== 0;
  const sgstExists = amt?.s && amt?.s !== 0;

  return igstExists || cgstExists || sgstExists;
};
const handleUpdateMultipleGstData = async(gstData, index) => {
  const companyId = gstData?.vId?.value || merchantValue?.value
  
  const gstFullData = {
      bsAmt:gstData?.bsAmt,
      vId:companyId,
      gstNo:gstData?.gstNo,
      amt:gstData?.amt || {},
      prc: gstData?.prc
  }
  
  const updateList = multipleAddGstInfo.map((item, i) => {
    if (i === index) {
      return {...item,gstFullData};
    } else return item;
  });
  const gstApplicable = isGstApplicable(gstFullData);
  setIsGst(gstApplicable)
  setMultipleAddGstInfo([...updateList]);
};
const isItemsAmountMismatch = useCallback(() => {
  const existiItems = editData?.pyInfo?.itms || [];
  return findMismatchedItems(existiItems,multipleItemList);
}, [editData, multipleItemList]);

const handleTaxableAmount = (amount)=>{
  if(!isEdit && amount){
    setTaxableAmount(amount)
  }
  else if(isItemsAmountMismatch() && amount){
    setTaxableAmount(amount)
  } else{
    setTaxableAmount(editData?.pyInfo?.txAmt)
  }
}
const handleTdsAmount = (amount)=>{
    if(isTds){
      setTdsAmount(amount)
    }
}
const handleAdjustmentAmount = (amount)=>{
  setAdjustmentAmount(amount)
}

const handleProjectChange = (newValue) => {
  if (role === 'Accountant') {
    const associatedClient = clientData?.find(c => c.prjs?.some(p => p._id === newValue?.value));
    if (associatedClient?._id) {
      setClientValue(clientOPtion?.find(o => o.value === associatedClient._id))
      setProjectValue(newValue);
    }
  } else {
    setProjectValue(newValue);
  }
}

const [isHovered, setIsHovered] = useState(false);

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={openPurchaseModal}
        onClose={() => closeModelForm()}
        size="xl"
        className="modal-main"
      >
        <ModalOverlay />
        <ModalContent
          top="0" // Position it at the top
          margin="0 auto" // Center it horizontally
          bottom="0"
          className="add-form-modal-content"
        >
          <div className="fixed-header">
            <ModalHeader className="expense-modal-header">
              Purchase Order - <span className="header-pr">{generatedNum}</span>
            </ModalHeader>
            <ModalCloseButton />
          </div>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <ModalBody>
              <Form className="addForm" onSubmit={formik.handleSubmit}>
                <div className="form-card">
                  <h5 className="mt-0">Purchase Order Details</h5>
                  <Row className="mt-2">
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          <span className="span-star">Purchase Order#*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="poNo"
                          placeholder="No"
                          value={generatedNum && generatedNum}
                          disabled
                        />
                      </Box>
                    </Col>

                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order - Month <span className="span-star">*</span>
                        </Form.Label>
                        <Box>
                          <DatePicker
                            className={`monthDate ${
                              isBlink ? "month_blink active" : ""
                            }`}
                            dateFormat="MM-yyyy"
                            showMonthYearPicker
                            name="orderMonth"
                            onChange={(e) => {
                              const dateTime = moment(e).format("yyyy-MM");
                              setGetPoMonth(dateTime);
                            }}
                            disabled={isEdit}
                            // defaultValue={new Date()}
                            selected={
                              getPoMonth ? new Date(moment(getPoMonth)) : ""
                            }
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                          />
                        </Box>
                      </Box>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Order Date <span className="span-star">*</span>
                        </Form.Label>
                        <Box>
                          <DatePicker
                            name="orderDate"
                            className={`monthDate ${
                              isBlink ? "date_blink active" : ""
                            }`}
                            dateFormat="dd-MMM-yyyy"
                            // disabled={isEdit}
                            onChange={(date) => {
                              setSelectedDate(date);
                            }}
                            selected={selectedDate}
                            minDate={startOfMonth}
                            maxDate={endOfMonth}
                            showMonthDropdown={false}
                            showYearDropdown={false}
                            dropdownMode="select"
                          />
                        </Box>
                      </Box>
                    </Col>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Delivery Date <span className="span-star">*</span>
                        </Form.Label>

                        <DatePicker
                          name="deliveryDate"
                          className={`monthDate`}
                          dateFormat="dd-MMM-yyyy"
                          disabled={isImmediate}
                          onChange={(date) => {
                            setDeliveryDate(date);
                          }}
                          selected={deliveryDate}
                          showMonthDropdown={false}
                          showYearDropdown={false}
                          dropdownMode="select"
                        />
                      </Box>
                      <Form.Check
                        type="checkbox"
                        name="Immediate"
                        label="Immediate"
                        className="immidate-checkbox"
                        checked={isImmediate}
                        onChange={(e) => setIsImmediate(e.target.checked)}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="form-card mt-0">
                  <h5>Expense</h5>
                  <Row>
                    <Col className="custom-select">
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Major Type <span className="span-star">*</span>
                        </Form.Label>

                        <CustomSelect
                          options={expenseOption}
                          placeHolder={<div>Type or select...</div>}
                          onChange={(newValue) => setExpenseValue(newValue)}
                          isSearchable
                          onCreateOption={(e) => {
                            createNewFormOption(createOption(e), "expense");
                          }}
                          onDeleteOption={(option) => {
                            deleteFormOption(option, "expense");
                          }}
                          onEditOption={(option, newValue) => {
                            editFormOption(option, newValue, "expense");
                          }}
                          defaultValue={expenseValue}
                          role={role}
                          isInvalid={errors?.expenseValue && !expenseValue}
                        />
                      </Box>
                      {errors?.expenseValue && !expenseValue && (
                        <p className="form_error">{errors?.expenseValue}</p>
                      )}
                    </Col>
                    {expenseValue ? (
                      <Col className="custom-select">
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Minor Type <span className="span-star">*</span>
                          </Form.Label>

                          <CustomSelect
                            options={minorTypeOption}
                            placeHolder={<div>Type or select...</div>}
                            onChange={(newValue) => setMinorTypeValue(newValue)}
                            isSearchable
                            onCreateOption={(e) => {
                              if (expenseValue?.value) {
                                createSubCategory(
                                  createOption(e),
                                  expenseValue
                                );
                              } else {
                                addToast("Please Select Major Type", {
                                  appearance: "error",
                                });
                              }
                            }}
                            onDeleteOption={(option) => {
                              deleteSubCategory(expenseValue?.id, option);
                            }}
                            onEditOption={(option, newValue) => {
                              editSubCategory(
                                expenseValue?.id,
                                option,
                                newValue
                              );
                            }}
                            defaultValue={minorTypeValue}
                            role={role}
                            isInvalid={
                              errors?.minorTypeValue && !minorTypeValue
                            }
                          />
                        </Box>
                        {errors?.minorTypeValue && !minorTypeValue && (
                          <p className="form_error">{errors?.minorTypeValue}</p>
                        )}
                      </Col>
                    ) : (
                      <Col></Col>
                    )}
                  </Row>
                  {minorTypeValue && (
                    <Row>
                      <Col className="custom-select">
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Minor Sub Category{" "}
                            <span className="span-star">
                              {minorSubCategoryOption &&
                              minorSubCategoryOption?.length
                                ? "*"
                                : ""}
                            </span>
                          </Form.Label>

                          <CustomSelect
                            options={minorSubCategoryOption}
                            placeHolder={<div>Type or select...</div>}
                            onChange={(newValue) =>
                              setMinorSubCategoryValue(newValue)
                            }
                            isSearchable
                            onCreateOption={(e) => {
                              if (minorTypeValue?.value) {
                                createMinorSubCategory(
                                  createOption(e),
                                  minorTypeValue
                                );
                              } else {
                                addToast("Please Select Minor Type", {
                                  appearance: "error",
                                });
                              }
                            }}
                            onDeleteOption={(option) => {
                              deleteMinorSubCategory(
                                minorTypeValue?.id,
                                option
                              );
                            }}
                            onEditOption={(option, newValue) => {
                              editMinorSubCategory(
                                minorTypeValue?.id,
                                option,
                                newValue
                              );
                            }}
                            defaultValue={minorSubCategoryValue}
                            role={role}
                            isInvalid={
                              errors?.minorSubCategoryValue &&
                              !minorSubCategoryValue
                            }
                          />
                        </Box>
                        {errors?.minorSubCategoryValue &&
                          !minorSubCategoryValue && (
                            <p className="form_error">
                              {errors?.minorSubCategoryValue}
                            </p>
                          )}
                      </Col>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>
                            Merchant Name{" "}
                            {paymentStatus === 0 && (
                              <span className="span-star">*</span>
                            )}
                            {""}
                          </Form.Label>
                          <div
                            className="merchant-field"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                          >
                            <ClientProjectSelect
                              options={merchantOption}
                              placeHolder={<div>Type or select...</div>}
                              onChange={(newValue) => {
                                setMerchantValue(newValue);
                                setIsHovered(false);
                              }}
                              isSearchable
                              defaultValue={merchantValue}
                              role={role}
                              isDisabled={
                                multipleCredit?.length && paymentStatus === 0
                              }
                              name="merchnatName"
                            />
                            {merchantValue?.value &&
                            totalCreditAmount &&
                            isHovered ? (
                              <Form.Text className="text-muted credit-amount-popover">
                                <Box className="" display="flex">
                                  <Box className="credit-amount-tag">
                                    {formatAmountInINR(totalCreditAmount || 0)}
                                  </Box>
                                </Box>
                              </Form.Text>
                            ) : (
                              ""
                            )}
                          </div>
                        </Box>

                        {errors?.merchantValue && !merchantValue && (
                          <p className="form_error">{errors?.merchantValue}</p>
                        )}
                      </Col>
                    </Row>
                  )}
                  {minorTypeValue && (
                    <>
                      <Row>
                        {role !== 'Accountant' ? <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>
                              Client Name{" "}
                              {paymentStatus === 0 && (
                                <span className="span-star">*</span>
                              )}
                            </Form.Label>

                            <ClientProjectSelect
                              options={clientOPtion}
                              placeHolder={<div>Type or select...</div>}
                              onChange={(newValue) => role !== 'Accountant' && handleUpdateClientValue(newValue)}
                              isSearchable
                              defaultValue={clientValue}
                              role={role}
                              isInvalid={errors?.clientValue && !clientValue}
                            />
                          </Box>
                          {errors?.clientValue && !clientValue && (
                            <p className="form_error">{errors?.clientValue}</p>
                          )}
                        </Col> : <Col></Col>}
                          <Col className="custom-select">
                            <Box display="flex" className="input-box">
                              <Form.Label>
                                Project Name{" "}
                                <span className="span-star">*</span>
                              </Form.Label>

                              <ClientProjectSelect
                                options={projectOption}
                                placeHolder={<div>Type or select...</div>}
                                onChange={(newValue) =>
                                  handleProjectChange(newValue)
                                }
                                isSearchable
                                defaultValue={projectValue}
                                role={role}
                                isInvalid={
                                  errors?.projectValue && !projectValue
                                }
                              />
                            </Box>
                            {errors?.projectValue && !projectValue && (
                              <p className="form_error">
                                {errors?.projectValue}
                              </p>
                            )}
                          </Col>
                      </Row>
                    </>
                  )}

                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>Remarks </Form.Label>
                        <TextAreaField
                          name="remarks"
                          value={remarksValue}
                          handleChange={(e) => handleRemarksChange(e)}
                          isInvalid={!!errors?.remarks}
                        />
                      </Box>
                    </Col>
                    <p className="form_error">{errors?.remarks}</p>
                  </Row>
                </div>
                <div className="form-card mt-3">
                  <h5>Payment Information</h5>
                  <Row>
                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Taxable Amount <span className="span-star">*</span>
                        </Form.Label>

                        <InputGroup className="input-group">
                          <InputGroup.Text>
                            <span className="rupee-symbol">₹</span>{" "}
                          </InputGroup.Text>
                          <CurrencyFormat
                            customInput={Form.Control}
                            className="amount-input"
                            type="text"
                            onValueChange={(e) => {
                              setTaxableAmount(e.value);
                            }}
                            name="taxableAmount"
                            value={taxableAmount}
                            disabled={isTDSPoGenerated()}
                            placeholder="0.00"
                            thousandSeparator={true}
                            // prefix={"$"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                            isInvalid={
                              (creditAmount && !taxableAmount) ||
                              errors?.taxableAmount
                            }
                          />
                        </InputGroup>
                      </Box>
                    </Col>

                    <Col>
                      <Box display="flex" className="input-box">
                        <Form.Label>
                          Requested Amount <span className="span-star">*</span>
                        </Form.Label>
                        <InputGroup className="input-group">
                          <InputGroup.Text>
                            <span className="rupee-symbol">₹</span>{" "}
                          </InputGroup.Text>
                          <CurrencyFormat
                            customInput={Form.Control}
                            className="amount-input"
                            type="text"
                            disabled
                            name="approvalAmount"
                            placeholder="Requested Amount"
                            value={approvalAmount || 0}
                            onValueChange={(e) => {
                              setApprovalAmount(e.value);
                            }}
                            isInvalid={
                              (remainingAmount < 0 &&
                                approvalAmount <= totalPaymentAmount) ||
                              (!approvalAmount && errors?.approvalAmount)
                            }
                            thousandSeparator={true}
                            // prefix={"$"}
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                          <InputGroup.Text className="quotation-upload">
                            {approvalAmount ? (
                              <div className="add-amoun-button">
                                <AmountPopover
                                  roundOfAmount={roundOfAmount}
                                  addAmount={(value) => {
                                    handleAddAmount(value);
                                  }}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            <Tooltip
                              label="Upload Quotation"
                              fontSize="md"
                              borderRadius="2xl"
                            >
                              <div
                                disabled={!approvalAmount}
                                className="position-relative"
                                onClick={() => {
                                  approvalAmount &&
                                    setOpenQuotation(!openQuotation);
                                }}
                              >
                                <FaFileUpload size={20} />
                                <span className="position-absolute top-0 start-100 translate-middle badge  bg-primary text-white">
                                  {quotationData?.files ||
                                  quotationData?.remarks
                                    ? allQuotation?.length + 1
                                    : allQuotation?.length || 0}
                                </span>
                              </div>
                            </Tooltip>
                          </InputGroup.Text>
                        </InputGroup>
                      </Box>
                      {((remainingAmount < 0 &&
                        approvalAmount <= totalPaymentAmount) ||
                        !approvalAmount) && (
                        <p className="form_error">{errors?.approvalAmount}</p>
                      )}
                    </Col>
                  </Row>

                  {paymentStatus === 1 && (
                    <>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Approved Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                className="amount-input"
                                type="text"
                                disabled
                                name="totalPayAmount"
                                placeholder="Total Amount"
                                value={
                                  totalPaymentAmount ? totalPaymentAmount : 0
                                }
                                thousandSeparator={true}
                                // prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Credit Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                className="amount-input"
                                type="text"
                                disabled
                                name="creditAmount"
                                placeholder="Credit Amount"
                                value={creditAmount || 0}
                                thousandSeparator={true}
                                // prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Net Payable Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                type="text"
                                className="amount-input"
                                disabled
                                name="Net Payable Amount"
                                value={remainingAmount ? remainingAmount : 0}
                                thousandSeparator={true}
                                decimalScale={2}
                                isInvalid={
                                  remainingAmount < 0 &&
                                  approvalAmount <= totalPaymentAmount
                                }
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                          {remainingAmount < 0 &&
                            approvalAmount <= totalPaymentAmount && (
                              <p className="form_error">
                                Net payable amount cannot be negative. Please
                                revise the request with an increased requested
                                amount and resubmit for approval.
                              </p>
                            )}
                        </Col>
                        <Col>
                          <Box display="flex" className="input-box">
                            <Form.Label>Total Spent Amount</Form.Label>
                            <InputGroup className="input-group">
                              <InputGroup.Text>
                                <span className="rupee-symbol">₹</span>{" "}
                              </InputGroup.Text>
                              <CurrencyFormat
                                customInput={Form.Control}
                                type="text"
                                disabled
                                className="amount-input"
                                name="totalPayAmount"
                                placeholder="Total Amount"
                                value={totalSpentAmount}
                                thousandSeparator={true}
                                // prefix={"$"}
                                decimalScale={2}
                                fixedDecimalScale={true}
                              />
                            </InputGroup>
                          </Box>
                        </Col>
                      </Row>
                    </>
                  )}

                  {paymentStatus !== 1 && (
                    <Row>
                      <Col>
                        <Box display="flex" className="input-box">
                          <Form.Label>Credit Amount</Form.Label>
                          <InputGroup className="input-group">
                            <InputGroup.Text>
                              <span className="rupee-symbol">₹</span>{" "}
                            </InputGroup.Text>
                            <CurrencyFormat
                              customInput={Form.Control}
                              className="amount-input"
                              type="text"
                              disabled
                              name="creditAmount"
                              placeholder="Credit Amount"
                              value={creditAmount || ""}
                              thousandSeparator={true}
                              // prefix={"$"}
                              decimalScale={2}
                              fixedDecimalScale={true}
                            />
                          </InputGroup>
                        </Box>
                      </Col>
                      <Col></Col>
                    </Row>
                  )}
                </div>

                <div>
                  <Tabs
                    defaultActiveKey={activeTab ? activeTab : "items"}
                    transition={false}
                    id="noanim-tab-example"
                    className="add-form-tabs expense-tabs"
                    onSelect={handleSelectTab}
                  >
                    <Tab
                      eventKey="items"
                      title={<div className="d-flex ">Items</div>}
                      className="add-form-tab"
                    >
                      <div className="form-card mt-0">
                        <Box>
                          <div>
                            <AddItemComponent
                              itemList={multipleItemList}
                              multipleAddGstInfo={multipleAddGstInfo}
                              handleListItem={(item, index) =>
                                handleMultipleListItem(item, index)
                              }
                              handleAddRow={() => handleAddRow()}
                              merchantValue={merchantValue}
                              handleDeleteRow={(e, index) =>
                                handleDeleteRow(e, index)
                              }
                              handleRemoveSelectedItem={(index) =>
                                handleRemoveSelectedItem(index)
                              }
                              handleUpdateList={(item, index) =>
                                handleUpdateListItem(item, index)
                              }
                              handleUpdateItemField={(value, name, index) =>
                                handleUpdateItemField(value, name, index)
                              }
                              getData={(item) =>
                                handleUpdateMultipleGstData(item, 0)
                              }
                              updateTaxableAmount={(amount) =>
                                handleTaxableAmount(amount)
                              }
                              isTdsPo={isTDSPoGenerated()}
                              handleAdjustmentAmount={(amount) =>
                                handleAdjustmentAmount(amount)
                              }
                              adjustmentAmount={adjustmentAmount}
                              editData={editData}
                              adjustmentLabel={adjustmentLabel}
                              handleAdjustmentLabel={(e)=>setAdjustmentLabel(e.target.value)}
                            />
                          </div>
                        </Box>
                      </div>
                    </Tab>
                    {paymentStatus === 1 && (
                      <Tab
                        eventKey="spent"
                        title="Spent Amount"
                        className="add-form-tab mx-0"
                      >
                        {activeTab === "spent" && (
                          <div className="form-card">
                            {paymentStatus === 1 &&
                              multipleAddPaymentInfo?.length > 0 &&
                              multipleAddPaymentInfo.map((item, index) => {
                                return (
                                  <PaymentInfoComponent
                                    key={`payment-info-${index}`}
                                    getData={(data) => {
                                      handleUpdateMultiplePayData(data, index);
                                    }}
                                    keepPayeeEnabled
                                    autoCount={index}
                                    paymentData={item}
                                    editData={editData}
                                    refreshEditData={refreshEditData}
                                    isEdit={isEdit}
                                    remainingAmount={remainingAmount}
                                    spentAmountError={spentAmountError}
                                    deleteMultipleListItem={() =>
                                      deleteMultipleListItem(index)
                                    }
                                    role={role}
                                    expenseType={expenseType}
                                    moduleInfo={moduleInfo}
                                    merchantValue={merchantValue}
                                  />
                                );
                              })}
                            <Box display="flex" alignItems="center">
                              <h5>Add Spent Amount</h5>

                              <Button
                                className="add-project mt-2 mx-1"
                                minWidth={0}
                                disabled={!remainingAmount}
                                onClick={() => {
                                  handleMultiplePayInfo(
                                    multipleAddPaymentInfo.length + 1
                                  );
                                }}
                              >
                                <FaPlusCircle
                                  className="add-project-icon"
                                  size={15}
                                />
                              </Button>
                            </Box>
                          </div>
                        )}
                      </Tab>
                    )}
                    {hasAccess() && (
                      <Tab
                        eventKey="Invoices"
                        title={
                          <div className="d-flex ">
                            Invoices
                            {multipleInvoiceData &&
                              multipleInvoiceData?.length > 0 && (
                                <FaCheck size={12} className="tab-icon" />
                              )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "Invoices" && (
                          <div className="form-card">
                            <Row>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Form.Label className="bill-number">
                                    Bill Number #
                                  </Form.Label>

                                  <Box>
                                    <Form.Control
                                      type="text"
                                      name="billNumber"
                                      placeholder="Bill Number"
                                      onChange={(e) => {
                                        setBillNumber(e.target.value);
                                      }}
                                      value={billNumber}
                                    />
                                  </Box>
                                </Box>
                              </Col>
                              <Col></Col>
                            </Row>
                            <div
                              className="form-card"
                              style={{ marginBottom: "0px" }}
                            >
                              <Box display="flex" alignItems="center">
                                <h5>Invoice</h5>
                                <Button
                                  className="add-project mt-1"
                                  onClick={() => {
                                    handleInvoiceChange();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                              <Box display="flex">
                                <span
                                  className=" mt-2"
                                  style={{ color: "red", fontSize: "14px" }}
                                >
                                  * File must be less then 2Mb
                                </span>
                                {multipleInvoiceData &&
                                  multipleInvoiceData?.length >= 5 && (
                                    <strong className="mx-4 mt-2">
                                      Maximum 5 allowed
                                    </strong>
                                  )}
                              </Box>
                              {multipleInvoiceData &&
                                multipleInvoiceData?.map((item, index) => {
                                  return (
                                    <InvoiceComponent
                                      key={`invoiceData-${index}`}
                                      getInvoice={(data) =>
                                        handleUpdateInvoiceData(data, index)
                                      }
                                      selectedFile={item}
                                      handleDelete={() => {
                                        handelDeleteInvoice(index);
                                      }}
                                      handleDeleteOnEdit={(key, spId) => {
                                        handleDeleteInvoiceOnEdit(key, spId);
                                      }}
                                      isEditing={isEdit}
                                      addNewInvoiceOnEdit={(file) => {
                                        addNewInvoiceOnEdit(file, index);
                                      }}
                                      submitInvRemark={(value) => {
                                        addRemarkForInvoice(value, index);
                                      }}
                                      handleAddInvoiceRemarks={(value) => {
                                        handleAddInvoiceRemarks(value, index);
                                      }}
                                      role={role}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        )}
                      </Tab>
                    )}
                    {hasAccess() && (
                      <Tab
                        eventKey="excel"
                        title={
                          <div className="d-flex">
                            Excel{" "}
                            <span className="mx-1 mt-1">
                              <RiFileDownloadLine />
                            </span>
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "excel" && (
                          <DownloadExcelFile
                            merchantValue={merchantValue}
                            prNo={generatedNum}
                            payAmount={totalPaymentAmount}
                            role={role}
                          />
                        )}
                      </Tab>
                    )}

                    <Tab
                      eventKey="tds"
                      title={
                        <div className="d-flex ">
                          TDS
                          {isTds && <FaCheck size={12} className="tab-icon" />}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === "tds" && (
                        <div className="form-card">
                          <Box display="flex" alignItems="center">
                            <h5>TDS Applicable</h5>
                            <Form.Check
                              className="mx-1 mt-2"
                              type="switch"
                              id="custom-switch"
                              onChange={() => setIsTds(!isTds)}
                              checked={isTds}
                              disabled={isTDSPoGenerated()}
                            />
                            {isTds && paymentStatus === 1 && (
                              <Box className="tds-po-gen" display="flex">
                                <Form.Label>
                                  Do you want to generate TDS PO?
                                </Form.Label>
                                <Form.Check
                                  type="switch"
                                  id="custom-switch"
                                  className="mx-1"
                                  disabled={isTDSPoGenerated()}
                                  onChange={handleToggleGenerateTDSPo}
                                  checked={
                                    isGenerateTDSPo || isTDSPoGenerated()
                                  }
                                  label={
                                    (isGenerateTDSPo || isTDSPoGenerated()) &&
                                    generatedTDSpoNum
                                  }
                                />
                              </Box>
                            )}
                          </Box>
                          {isTds && (
                            <Box>
                              <PurchaseItemTds
                                itemList={multipleItemList}
                                handleUpdateItemField={(value, name, index) =>
                                  handleUpdateItemField(value, name, index)
                                }
                                updateTdsAmount={(amount) =>
                                  handleTdsAmount(amount)
                                }
                                tdsAmount={tdsAmount}
                                isTdsPo={isTDSPoGenerated()}
                              />
                            </Box>
                          )}
                        </div>
                      )}
                    </Tab>

                    {hasAccess() && (
                      <Tab
                        eventKey="freight_expense"
                        title={
                          <div className="d-flex ">
                            Freight Expense
                            {isFreight && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "freight_expense" && (
                          <div>
                            <Row className="mt-3 mb-0">
                              <Col>
                                <Box display="flex" className="mb-3">
                                  <Form.Label>
                                    Is it Freight Expense?
                                  </Form.Label>
                                  <Form.Check
                                    className="mx-3 mt-0"
                                    type="switch"
                                    id="custom-switch"
                                    onChange={() => setIsFreight(!isFreight)}
                                    checked={isFreight}
                                  />
                                </Box>
                              </Col>
                            </Row>
                            {isFreight && (
                              <>
                                <Row className="mt-0 mb-3">
                                  <Col>
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Delivery Partner</Form.Label>
                                      <CustomSelect
                                        options={agencyOption}
                                        placeHolder={
                                          <div>Type or select...</div>
                                        }
                                        onChange={(newValue) =>
                                          setAgencyValue(newValue)
                                        }
                                        isSearchable
                                        onCreateOption={(e) => {
                                          createNewFormOption(
                                            createOption(e),
                                            "agency"
                                          );
                                        }}
                                        onDeleteOption={(option) => {
                                          deleteFormOption(option, "agency");
                                        }}
                                        onEditOption={(option, newValue) => {
                                          editFormOption(
                                            option,
                                            newValue,
                                            "agency"
                                          );
                                        }}
                                        defaultValue={agencyValue}
                                        role={role}
                                      />
                                    </Box>
                                  </Col>
                                  <Col>
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Tracking Number</Form.Label>

                                      <Form.Control
                                        type="text"
                                        name="trackingNum"
                                        placeholder="Tracking Number"
                                        {...formik.getFieldProps("trackingNum")}
                                        defaultValue="XYZabc456qzvytr"
                                      />
                                    </Box>
                                  </Col>
                                </Row>
                              </>
                            )}
                          </div>
                        )}
                      </Tab>
                    )}
                    {hasAccess() && (
                      <Tab
                        eventKey="refund"
                        title={
                          <div className="d-flex ">
                            Refund
                            {isRefund && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        disabled={!multipleAddPaymentInfo?.length}
                        className="add-form-tab"
                      >
                        {activeTab === "refund" && (
                          <div className="form-card">
                            <Box display="flex" alignItems="center">
                              <h5>Refund Information</h5>
                              <Form.Check
                                className="mx-1 mt-2"
                                type="switch"
                                id="custom-switch"
                                checked={isRefund}
                                onChange={() => handleToggleRefundApplicable()}
                              />
                            </Box>

                            {isRefund && (
                              <Box>
                                {multipleAddRefundInfo &&
                                  multipleAddRefundInfo?.map((item, index) => {
                                    return (
                                      <RefundInfoListComponent
                                        key={`refundInfo-${index}`}
                                        getData={(data) => {
                                          handleUpdateMultipleRefundData(
                                            data,
                                            index
                                          );
                                        }}
                                        autoCount={index}
                                        paymentData={item}
                                        editData={editData}
                                        refreshEditData={refreshEditData}
                                        deleteMultipleListItem={() =>
                                          deleteMultipleRefundListItem(index)
                                        }
                                        remainingAmount={remainingAmount}
                                        refundAmountError={refundAmountError}
                                        expenseType={expenseType}
                                        role={role}
                                      />
                                    );
                                  })}
                              </Box>
                            )}
                            {isRefund && (
                              <Box display="flex" alignItems="center">
                                <h5>Add Refund</h5>

                                <Button
                                  className="add-project mt-2"
                                  onClick={() => {
                                    handleMultipleRefundInfo(
                                      multipleAddRefundInfo.length + 1
                                    );
                                  }}
                                  disabled={!isRefund}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                            )}
                          </div>
                        )}
                      </Tab>
                    )}
                    {hasAccess() && (
                      <Tab
                        eventKey="reimbursement"
                        title={
                          <div className="d-flex ">
                            Reimbursement
                            {formik.values.isReimburse && (
                              <FaCheck size={12} className="tab-icon" />
                            )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "reimbursement" && (
                          <div className="form-card">
                            <Box
                              display="flex"
                              className="mb-3"
                              alignItems="center"
                            >
                              <h5>Reimbursement Information</h5>
                              <Form.Check
                                className="mx-1 mt-2"
                                type="switch"
                                id="custom-switch"
                                checked={formik.values.isReimburse}
                                {...formik.getFieldProps("isReimburse")}
                              />
                            </Box>

                            {formik.values.isReimburse && (
                              <Box>
                                <Row>
                                  <Col>
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Invoice Number</Form.Label>{" "}
                                      <Form.Control
                                        type="text"
                                        name="invoiceNum"
                                        placeholder="Invoice Number"
                                        defaultValue=""
                                        {...formik.getFieldProps("invoiceNum")}
                                      />
                                    </Box>
                                    <p className="form_error">
                                      {formik.errors.invoiceNum}
                                    </p>
                                  </Col>
                                  <Col>
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Invoice Date</Form.Label>
                                      <Box>
                                        <DatePicker
                                          name="invoiceDate"
                                          className="monthDate"
                                          dateFormat="dd-MMM-yyyy"
                                          selected={invoiceDate}
                                          onChange={(date) =>
                                            setInvoiceDate(date)
                                          }
                                          showMonthDropdown
                                          showYearDropdown
                                          dropdownMode="select"
                                        />
                                      </Box>
                                    </Box>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col className="switch-col mt-1">
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Payment Date </Form.Label>

                                      <DatePicker
                                        name="reimbursePaymentDate"
                                        className="monthDate"
                                        dateFormat="dd-MMM-yyyy"
                                        selected={reimbursePaymentDate}
                                        onChange={(date) =>
                                          setReimbursePaymentDate(date)
                                        }
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                      />
                                    </Box>
                                  </Col>
                                  <Col>
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Currency</Form.Label>
                                      <CustomSelect
                                        options={currencyOption}
                                        placeHolder={
                                          <div>Type or select...</div>
                                        }
                                        onChange={(newValue) =>
                                          setCurrencyValue(newValue)
                                        }
                                        isSearchable
                                        onCreateOption={(e) => {
                                          createNewFormOption(
                                            createOption(e),
                                            "currency"
                                          );
                                        }}
                                        onDeleteOption={(option) => {
                                          deleteFormOption(option, "currency");
                                        }}
                                        onEditOption={(option, newValue) => {
                                          editFormOption(
                                            option,
                                            newValue,
                                            "currency"
                                          );
                                        }}
                                        defaultValue={currencyValue}
                                        role={role}
                                      />
                                    </Box>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Amount</Form.Label>
                                      <CurrencyFormat
                                        customInput={Form.Control}
                                        type="text"
                                        onValueChange={(e) => {
                                          setTotalAmount(e.value);
                                        }}
                                        name="reimburseAmount"
                                        defaultValue={totalAmount}
                                        value={totalAmount || ""}
                                        thousandSeparator={true}
                                        decimalScale={2}
                                        fixedDecimalScale={true}
                                      />
                                    </Box>
                                  </Col>
                                  <Col>
                                    <Box display="flex" className="input-box">
                                      <Form.Label>Conversion Rate</Form.Label>

                                      <Form.Control
                                        type="number"
                                        name="conversionRate"
                                        placeholder="Coversion Rate"
                                        disabled={
                                          currencyValue &&
                                          currencyValue?.value === "INR"
                                        }
                                        onChange={(e) => {
                                          setINRVal(e.target.value);
                                        }}
                                        defaultValue={INRVal}
                                      />
                                    </Box>
                                  </Col>
                                </Row>
                                {currencyValue?.label !== "INR" && (
                                  <>
                                    <Row>
                                      <Col>
                                        <Box
                                          display="flex"
                                          className="input-box"
                                        >
                                          <Form.Label>Amount in INR</Form.Label>
                                          <InputGroup>
                                            <InputGroup.Text>
                                              <span className="rupee-symbol">
                                                ₹
                                              </span>{" "}
                                            </InputGroup.Text>
                                            <CurrencyFormat
                                              customInput={Form.Control}
                                              type="text"
                                              onValueChange={
                                                formik.handleChange
                                              }
                                              name="amountInINR"
                                              disabled
                                              value={convertedVal || ""}
                                              thousandSeparator={true}
                                              decimalScale={2}
                                              fixedDecimalScale={true}
                                            />
                                          </InputGroup>
                                        </Box>
                                      </Col>
                                      <Col></Col>
                                    </Row>
                                  </>
                                )}
                              </Box>
                            )}
                          </div>
                        )}
                      </Tab>
                    )}

                    <Tab
                      eventKey="credit"
                      title={
                        <div className="d-flex ">
                          Credit
                          {isCredit && (
                            <FaCheck size={12} className="tab-icon" />
                          )}
                        </div>
                      }
                      className="add-form-tab"
                    >
                      {activeTab === "credit" && (
                        <div className="form-card">
                          <Box display="flex" alignItems="center">
                            <h5>Credit Utilized</h5>
                            <Form.Check
                              className="mx-1 mt-2"
                              type="switch"
                              id="custom-switch"
                              checked={isCredit}
                              onChange={() => handleToggleCreditApplicable()}
                            />
                            {paymentStatus === 1 && hasAccess() && (
                              <div
                                className="add-credit-btn"
                                onClick={() => setIsAddCredit(!isAddCredit)}
                              >
                                <FaPlus
                                  size={12}
                                  className="new-plus-icon mx-1"
                                />{" "}
                                New Credit
                              </div>
                            )}
                          </Box>
                          {isCredit && (
                            <Box>
                              {multipleCredit &&
                                multipleCredit?.map((item, index) => {
                                  const isLastItem =
                                    index === multipleCredit.length - 1;

                                  return (
                                    <CreditApplicable
                                      autoCount={index}
                                      isEdit={isEdit}
                                      getData={(data) =>
                                        handleUpdatedMultipleCredit(data)
                                      }
                                      creditItem={item}
                                      deleteCredit={(id, creditId) =>
                                        handleDeleteCredit(id, creditId)
                                      }
                                      creditError={creditError}
                                      editData={editData}
                                      maxAllowedCredit={
                                        remainingAmount + parseFloat(item?.usAmt || 0)
                                      }
                                      isCreditValid={setCreditValid}
                                      allCreditData={allCreditData}
                                      isDisabled={!isLastItem}
                                    />
                                  );
                                })}
                            </Box>
                          )}

                          {isCredit && (
                            <Box display="flex" alignItems="center">
                              <h5>Add Credit</h5>

                              <Button
                                className="add-project mt-2"
                                onClick={() => setAddCredit(!addCredit)}
                                disabled={!validateCredits() || !isCredit}
                              >
                                <FaPlusCircle
                                  className="add-project-icon"
                                  size={15}
                                />
                              </Button>
                              <Box className="mt-2 mx-4">
                                {addCredit && (
                                  <ClientProjectSelect
                                    options={allCreditOption}
                                    placeHolder={
                                      <div>Select Credit Number...</div>
                                    }
                                    onChange={(newValue) =>
                                      handleAddCredit(newValue)
                                    }
                                    isSearchable
                                    role={role}
                                  />
                                )}
                              </Box>
                            </Box>
                          )}
                        </div>
                      )}
                    </Tab>
                    {!hasAccess() && (
                      <Tab
                        eventKey="Invoices"
                        title={
                          <div className="d-flex ">
                            Invoices
                            {multipleInvoiceData &&
                              multipleInvoiceData?.length > 0 && (
                                <FaCheck size={12} className="tab-icon" />
                              )}
                          </div>
                        }
                        className="add-form-tab"
                      >
                        {activeTab === "Invoices" && (
                          <div className="form-card">
                            <Row>
                              <Col>
                                <Box display="flex" className="input-box">
                                  <Form.Label className="bill-number">
                                    Bill Number #
                                  </Form.Label>

                                  <Box>
                                    <Form.Control
                                      type="text"
                                      name="billNumber"
                                      placeholder="Bill Number"
                                      onChange={(e) => {
                                        setBillNumber(e.target.value);
                                      }}
                                      value={billNumber}
                                    />
                                  </Box>
                                </Box>
                              </Col>
                              <Col></Col>
                            </Row>
                            <div
                              className="form-card"
                              style={{ marginBottom: "0px" }}
                            >
                              <Box display="flex" alignItems="center">
                                <h5>Invoice</h5>
                                <Button
                                  className="add-project mt-1"
                                  onClick={() => {
                                    handleInvoiceChange();
                                  }}
                                >
                                  <FaPlusCircle
                                    className="add-project-icon"
                                    size={15}
                                  />
                                </Button>
                              </Box>
                              <Box display="flex">
                                <span
                                  className=" mt-2"
                                  style={{ color: "red", fontSize: "14px" }}
                                >
                                  * File must be less then 2Mb
                                </span>
                                {multipleInvoiceData &&
                                  multipleInvoiceData?.length >= 5 && (
                                    <strong className="mx-4 mt-2">
                                      Maximum 5 allowed
                                    </strong>
                                  )}
                              </Box>
                              {multipleInvoiceData &&
                                multipleInvoiceData?.map((item, index) => {
                                  return (
                                    <InvoiceComponent
                                      key={`invoiceData-${index}`}
                                      getInvoice={(data) =>
                                        handleUpdateInvoiceData(data, index)
                                      }
                                      selectedFile={item}
                                      handleDelete={() => {
                                        handelDeleteInvoice(index);
                                      }}
                                      handleDeleteOnEdit={(key, spId) => {
                                        handleDeleteInvoiceOnEdit(key, spId);
                                      }}
                                      isEditing={isEdit}
                                      addNewInvoiceOnEdit={(file) => {
                                        addNewInvoiceOnEdit(file, index);
                                      }}
                                      submitInvRemark={(value) => {
                                        addRemarkForInvoice(value, index);
                                      }}
                                      handleAddInvoiceRemarks={(value) => {
                                        handleAddInvoiceRemarks(value, index);
                                      }}
                                      role={role}
                                    />
                                  );
                                })}
                            </div>
                          </div>
                        )}
                      </Tab>
                    )}
                  </Tabs>
                </div>

                {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 && (
                    <>
                      <div className="form-card">
                        <h5>Approve OR Reject Remark</h5>

                        <Row>
                          <Col>
                            <Box display="flex" className="input-box">
                              <Form.Label>Remarks</Form.Label>
                              <TextAreaField
                                name="remarks"
                                value={approveOrRejectRemarks}
                                handleChange={(e) =>
                                  setApproveOrRejectRemarks(e.target.value)
                                }
                                isInvalid={
                                  !approveOrRejectRemarks &&
                                  errors?.approveOrRejectRemarks
                                }
                              />
                             
                            </Box>
                            {!approveOrRejectRemarks && (
                              <p className="form_error">
                                {errors?.approveOrRejectRemarks}
                              </p>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}
                <Row>
                  {(role === "Manager" || role === "Admin") &&
                  activeList === "pending" &&
                  isEdit &&
                  paymentStatus === 0 ? (
                    <ModalFooter
                      style={{ alignItems: "center", justifyContent: "center" }}
                    >
                      {paymentStatus !== 1 && (
                        <div className="d-flex">
                          <Button
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => {
                              handleTotalPayAmountIsApproved(formik.values);
                            }}
                            className="submit-btn me-2"
                          >
                            Approve
                          </Button>

                          <Button
                            className="submit-btn"
                            variant="brand"
                            disabled={
                              totalPaymentAmount === null ? true : false
                            }
                            onClick={() => handleTotalPayAmountIsRejected()}
                            style={{ background: "#191063" }}
                          >
                            Reject
                          </Button>
                        </div>
                      )}
                    </ModalFooter>
                  ) : (
                    <ModalFooter>
                      {isSendRequest() ? (
                        <Button
                          variant="brand"
                          disabled={totalPaymentAmount === null ? true : false}
                          onClick={() => {
                            handleAmountApproveBtn(formik.values);
                          }}
                          className="submit-btn"
                        >
                          Send Request
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          variant="brand"
                          className="submit-btn"
                          onClick={() => setCompareDataModal(true)}
                          style={{ background: "#191063" }}
                        >
                          Submit
                        </Button>
                      )}
                    </ModalFooter>
                  )}
                </Row>
              </Form>
            </ModalBody>
          )}
        </ModalContent>
      </Modal>

      {compareDataModal && comparingData && (
        <ExpenseDataChangeModal
          openModal={compareDataModal}
          closeModal={closeComparedDataModal}
          editData={editData}
          currentData={comparingData}
          isConfirmed={() => {
            submitUpdateData(comparingData, editData);
          }}
          type={expenseType}
          role={role}
          moduleTyp={moduleInfo?.typ}
        />
      )}
      {openQuotation && (
        <QuotationForm
          isOpen={openQuotation}
          closeModal={() => {
            handleCloseQuotation();
          }}
          requestedAmount={approvalAmount}
          handleData={(data) => handleQuotationData(data)}
          uploadedData={quotationData}
          expenseId={editData?._id || ""}
          allQuotation={allQuotation}
        />
      )}
      {isAddCredit && (
        <CreditForm
          isOpen={isAddCredit}
          closeModal={() => {
            setIsAddCredit(false);
          }}
          remainingAmount={totalPaymentAmount}
          editData={editData}
          expenseType="PurchaseOrder"
          vendorId={merchantValue}
          role={role}
          moduleInfo={moduleInfo}
        />
      )}
    </>
  );
};

export default PurchaseOrderForm;
